<template>
  <!-- NAVBAR-BRAND -->
  <div>
    <!-- HEADER -->
    <div class="home__head">
      <div class="navbar navbar-expand-lg"
        style="position: fixed; top: 0; width: 100%; z-index: 1000; background-color: #fff; padding: 0; box-shadow: 0px 4px 16px 0px rgba(69, 74, 108, 0.08); !important">
        <div class="container">
          <router-link :to="{ name: 'home' }" class="navbar-brand">
            <!-- <img :src="require('@/assets/images/app/logo-Inter.png')" loading="lazy" alt="" /> -->
            <img style="width: 220px; height: auto" :src="require('@/assets/images/app/logos-Inter.png')" loading="lazy"
              alt="" />
          </router-link>
          <button class="navbar-toggler" type="button" v-b-toggle.nav-head>
            <img :src="require('@/assets/images/app/Menu.png')" alt="" />
          </button>
          <b-collapse class="collapse navbar-collapse" id="nav-head">
            <ul class="navbar-nav ms-auto" style="z-index: 1000">
            </ul>
          </b-collapse>
        </div>
      </div>
    </div>

    <!--div-- class="home__banner-sorteo visible-mobile">
      <a href="https://docs.google.com/document/d/1pp31DLK4HY2Fr6SWgzM0UhE161J2krYRk4dOe9OIWA0/edit"
        target="_blank">
        <div class="contenedor">
          <img :src="require('@/assets/images/app/navidad_mobile.png')" alt="" />
        </div>
      </a>
    </div-->
    <!-- COUNTDOWN -->
    <div class="visible-mobile" style="margin-top:50px">
      <a class="text-decoration-none"
        :href="'https://wa.link/o1y194?utm_source=botmaker&utm_medium=whatsapp&utm_campaign=promocion_rumbo-botmaker-whatsapp-pf-on-rumbo-ahorro'"
        target="_blank">
        <div class="countdown" v-if="currentStep.key === 'goal'">
          <div class="countdown__content">
            <div class="countdown__content__wpp">
              <a :href="'https://wa.link/o1y194?utm_source=botmaker&utm_medium=whatsapp&utm_campaign=promocion_rumbo-botmaker-whatsapp-pf-on-rumbo-ahorro'"
                target="_blank"><img src="../../../src/assets/images/app/barbas-mobile.png" alt="" />
              </a>
            </div>

            <div class="countdown__content__gift">
              <div class="countdown__content__gift__text__title">
                <span>Te regalamos
                  <img src="../../../src/assets/images/app/noto_wrapped-gift.svg" alt="" />
                  tu</span>
              </div>
              <div class="countdown__content__gift__text__subtitle">
                <span class="countdown__content__gift__text__subtitle__spanMonthFree">2DO MES GRATIS*</span>
              </div>
            </div>

            <div class="countdown__counter">
              <div class="countdown__counter__item1">
                <div class="countdown__counter__item1__element1">
                  <div class="countdown__counter__item1__number">
                    <h6>
                      {{ hours }}
                    </h6>
                  </div>
                  <span>Horas</span>
                </div>

                <div class="countdown__counter__item1__element2">
                  <div class="countdown__counter__item1__number">
                    <h6>
                      {{ minutes < 10 ? "0" + minutes : minutes }} </h6>
                  </div>
                  <span>Minutos</span>
                </div>

                <div class="countdown__counter__item1__element3">
                  <div class="countdown__counter__item1__number">
                    <h6>
                      {{ seconds < 10 ? "0" + seconds : seconds }} </h6>
                  </div>
                  <span>Segundos</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="visible-mobile">
          <div class="promotion" v-if="currentStep.key === 'goal'">
            <span>*Un mes gratis por cliente, para aportes hasta S/400.</span>
          </div>
        </div>
      </a>

      <div class="headerInfo" v-if="currentStep.key === 'userInfo'">
        <div class="headerInfo__content">
          <span>Descubre el
            <img src="../../../src/assets/images/app/noto_wrapped-gift.svg" alt="" />
            que tenemos para ti en el paso 2
          </span>
        </div>
      </div>
    </div>

    <!-- QUOTE -->
    <div class="quote" >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-10 col-sm-10 col-11">
            <a class="btn-back" v-if="!flags.paymentCompleted" role="button" @click="prevStep()">
              <img :src="require('@/assets/images/app/arrow-back.svg')" alt="" />
              Regresar
            </a>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-10 col-sm-10 col-11">
            <div class="row justify-content-center" v-if="!flags.paymentCompleted">
              <div class="col-md-3 col-sm-4 col-12">
                <div class="quote__stepper">
                  <template v-for="(step, index) in steps" v-bind:key="step.key">
                    <div class="quote__stepper__item" @click="navigateToStep(step)" v-if="step.key !== 'userInfo'" :class="{
                      active: step.active,
                      completed: step.completed,
                    }">
                      {{ step.order }}
                      <div class="name">{{ step.label }}</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="quote__step">
              <a class="quote__step__back" v-if="!flags.paymentCompleted" role="button" @click="prevStep()">
                <img :src="require('@/assets/images/app/arrow-back.svg')" alt="" />
              </a>
              <h4 class="quote__step__title" v-if="!flags.paymentCompleted">
                {{ currentStep.title }}
              </h4>
              <template v-if="!flags.paymentCompleted">
                <template v-if="currentStep.key === 'userInfo'">
                  <div class="personal-date row justify-content-center">
                    <div class="col-md-5 col-sm-6 col-12">
                      <div class="hidden-mobile">
                        <div class="headerInfo">
                          <div class="headerInfo__content">
                            <span>Descubre el
                              <img src="../../../src/assets/images/app/noto_wrapped-gift.svg" alt="" />
                              que tenemos para ti en el paso 2
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="personal-date__card card card-form">
                        <div class="card-body mt-2">
                          <form action="">
                            <!-- User -->
                            <div class="row">
                              <div class="col-xs-12 col-md-12 col-sm-12 col-12">
                                <div class="form-group" :class="{
                                  invalid:
                                    this.v$.userInfo.firstName.$error,
                                }">
<!--                                  @click="cleanInput('firstName')"-->
<!--                                  @keydown="validateInput($event,/^[a-zA-Z\s]*$/)"-->
                                  <input type="text" class="form-control" placeholder="Nombres" :disabled="flags.searching" v-model="this.v$.userInfo.firstName.$model"/>
                                  <small>Por favor ingresa tu nombre</small>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xs-12 col-md-6 col-sm-6 col-6">
                                <div class="form-group" :class="{
                                  invalid:
                                    this.v$.userInfo.lastName.$error,
                                }">
<!--                                  @click="cleanInput('lastName')"-->
                                  <!--                                  @keydown="validateInput($event,/^[a-zA-Z\s]*$/)"-->
                                  <input type="text" class="form-control" placeholder="Apellido paterno" :disabled="flags.searching" v-model="this.v$.userInfo.lastName.$model"  />
                                  <small>Por favor ingresa tu apellido paterno</small>
                                </div>
                              </div>
                              <div class="col-xs-12 col-md-6 col-sm-6 col-6">
                                <div class="form-group" :class="{
                                  invalid:
                                    this.v$.userInfo.secondLastName.$error,
                                }">
<!--                                  @click="cleanInput('secondLastName')"-->
<!--                                  @keydown="validateInput($event,/^[a-zA-Z\s]*$/)"-->
                                  <input type="text" class="form-control" placeholder="Apellido materno" :disabled="flags.searching" v-model="this.v$.userInfo.secondLastName.$model" />
                                  <small>Por favor ingresa tu apellido materno</small>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xs-12 col-md-6 col-sm-6 col-6">
                                <div class="form-group" :class="{invalid:this.v$.userInfo.dateOfBirth.$error || flags.invalidAge,}">
                                  <input type="text" class="form-control" placeholder="Fecha de nacimiento" v-model="this.v$.userInfo.inputDob.$model" @click="changePlaceholder" @blur="revertPlaceholder" @keyup="validateDob" v-mask="'##/##/####'" />
                                  <small v-if="!flags.invalidAge">Por favor ingresa tu fecha de nacimiento</small>
                                  <small v-if="flags.invalidAge">Por favor ingresa una fecha v&aacute;lida</small>
                                </div>
                              </div>
                              <div class="col-xs-12 col-md-6 col-sm-6 col-6">
                                <div class="form-group" :class="{invalid: this.v$.userInfo.gender.$error,}">
                                  <select class="form-select form-control" aria-label="Default select example" v-model="this.v$.userInfo.gender.$model">
                                    <option disabled value="--" selected>
                                      Género
                                    </option>
                                    <option value="M">Masculino</option>
                                    <option value="F">Femenino</option>
                                  </select>
                                  <small>Por favor selecciona tu g&eacute;nero</small>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xs-12 col-md-6 col-sm-6 col-6">
                                <div class="form-group" :class="{invalid: this.v$.userInfo.phone.$error,}">
<!--                                  @click="cleanInput('phone')"-->
                                  <input type="text" class="form-control" v-model="this.v$.userInfo.phone.$model" @keydown="validateInput($event, /^[0-9]*$/)" maxlength="9" placeholder="Celular" data-culqi="card[phone]" id="card[phone]"/>
                                  <small>Por favor ingresa tu número de celular</small>
                                </div>
                              </div>
                              <div class="col-xs-12 col-md-6 col-sm-6 col-6">
                                <div class="form-group" :class="{invalid: this.v$.userInfo.email.$error,}">
<!--                                  @click="cleanInput('email')"-->
                                  <input type="email" class="form-control" placeholder="Correo electrónico" :disabled="flags.searching" v-model="this.v$.userInfo.email.$model" data-culqi="card[email]" id="card[email]"/>
                                  <small>Por favor ingresa tu correo electrónico</small>
                                </div>
                              </div>
                            </div>

                            <div class="form-group" v-if="flags.olderThanAllowedAge">
                              <div class="alert text-center text-danger" role="alert" style="padding: 0.71rem 1rem">
                                En estos momentos no contamos con un plan que se
                                adecúe a tus necesidades.
                              </div>
                            </div>
                            <div class="form-group mt-2">
                              <button class="btn btn-pink btn-send" type="button" :disabled="flags.searching"
                                @click="nextStep()">
                                Continuar
                              </button>
                            </div>
                            <!--div class="policies">
                              Al continuar acepto las
                              <a href="https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro-1810.pdf"
                                target="_blank">Políticas de Privacidad</a>
                            </div>
                            <div class="policies">
                              <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="chkbxPolicies"
                                  v-model="policies" />
                                <label class="custom-control-label" for="chkbxPolicies">Acepto las&nbsp;<a role="button"
                                    v-b-modal.comunications-policies-modal>Pol&iacute;ticas de comunicaciones</a>
                                </label>
                              </div>
                              <small class="text-danger" v-if="flags.errorPolicy && !policies">*Debes aceptar las
                                Pol&iacute;ticas de
                                comunicaciones</small>
                            </div-->
                          </form>
                        </div>

                        <div class="visible-mobile">
                          <div class="contentwpp">
                            <a class="btn btn-wapp" target="_blank" href="tel:016149288">
                              <img :src="require('@/assets/images/app/newWpp.png')" alt="" width="160" loading="lazy" />
                              <span>Quiero comunicarme con un asesor</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <!--DESKTOP -->
                <template v-if="currentStep.key === 'goal'">
                  <div class="row d-flex justify-content-center">
                    <div class="programSavings pt-2 col-md-5 col-sm-5 col-12">
                      <div class="card card-form">
                        <div class="programSavings__card">
                          <div class="card-body">
                            <form action="">
                              <div class="ahorroMes form-group">
                                <label for="" class="d-block text-center pb-2"><b>¿Cuánto deseas ahorrar al
                                    mes?</b></label>

                                <div class="amount-selector">
                                  <!--
<VueSlider :min="amountSlider.min"
                                                                        :max="amountSlider.max"
                                                                        :interval="amountSlider.interval" :dotSize="25"
                                                                        :width="'100%'" :height="'10px'"
                                                                        :tooltip="'always'"
                                                                        v-model="this.v$.goal.amount.$model"/>

                                                                    -->

                                  <Slider v-model="this.v$.goal.amount.$model" :step="amountSlider.interval"
                                    :format="{ prefix: 'S/ ' }" :min="amountSlider.min" :max="amountSlider.max"
                                    :orientation="'horizontal'" @change="changeAmount"></Slider>

                                  <!--
                                                                    <vue3-slider v-model="this.v$.goal.amount.$model"
                                                                        :height="6" :handleScale="2.5"
                                                                        :color="'#0855c4'" :track-color="'#c5c5c5'"
                                                                        :min="amountSlider.min" :max="amountSlider.max"
                                                                        :step="amountSlider.interval" :tooltip="true"
                                                                        :tooltipText="'S/%v'"
                                                                        :tooltipTextColor="'#0855c4'"
                                                                        @change="changeAmount" />

                                                                        -->

                                  <span class="min">S/
                                    {{ formatNumber(amountSlider.min) }}</span>
                                  <span class="min">S/
                                    {{ formatNumber(amountSlider.max) }}</span>
                                </div>
                              </div>
                              <div class="yearSaving form-group" v-if="!flags.loadingPlans">
                                <label for="" class="d-block text-center mb-2"><b>¿Por cuántos años deseas
                                    ahorrar?</b></label>
                                <div class="period-selector">
                                  <div class="custom-control custom-radio custom-control-inline"
                                    v-for="(option, index) in options" v-bind:key="option.id">
                                    <input type="radio" :id="'radioPlan' + option.id" name="radioPlan"
                                      class="custom-control-input" :value="option.id" v-model="goal.option"
                                      @change="changeOption(option)" />
                                    <label class="custom-control-label" v-bind:for="'radioPlan' + option.id">{{
                                      option.duration }} años</label>
                                  </div>
                                </div>
                              </div>
                              <div class="loader text-center" v-if="flags.loadingPlans">
                                <i class="fas fa-circle-notch fa-spin text-main"></i>
                                <h4 class="text-second">Cargando planes</h4>
                              </div>
                              <div v-if="allOptions.length === 0 && !flags.loadingPlans
                                ">
                                <h3 class="text-main text-center">
                                  No hemos encontrado un plan para ti
                                </h3>
                              </div>

                              <div class="visible-mobile">
                                <div class="card card-plan w-100" v-if="selectedOption">
                                  <div class="card-body">
                                    <div class="card-plan__item">
                                      <span>Mi aporte total</span>
                                      <b>S/
                                        {{
                                          formatNumber(selectedOption.saved)
                                        }}</b>
                                    </div>
                                    <div class="card-plan__item">
                                      <span>Mi ganancia</span>
                                      <b>S/
                                        {{
                                          formatNumber(selectedOption.won)
                                        }}</b>
                                    </div>
                                    <div class="card-plan__item">
                                      <span>Devolución total</span>
                                      <b>S/
                                        {{
                                          formatNumber(selectedOption.amount)
                                        }}</b>
                                    </div>
                                  </div>
                                  <div class="card-footer">
                                    <span>
                                      Mi TREA <br />
                                      con este plan es:
                                    </span>
                                    <div class="interest ml-auto">
                                      {{ selectedOption.tea }}%
                                      <!-- <span class="d-block">(TEA
                                        referencial)</span> -->
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="programSavings__content">
                                <h6 class="rememberme text-center mb-2 mt-4">
                                  Recuerda que:
                                </h6>
                                <label for="" class="d-block text-center">Tu ahorro incluye un seguro de vida por
                                  <br />
                                  S/ 25,000 para proteger a los que más
                                  amas.</label>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div class="visible-mobile">
                        <div class="btnPink row">
                          <div class="col">
                            <div class="text-center form-group">
                              <button class="btn btn-pink btn-send" @click="setOption(selectedOption)">
                                Continuar
                              </button>
                            </div>
                            <div class="text-center form-group">
                              <button class="btn btn-outline-main btn-quote" type="button" @click="openQuoteModal()">
                                Enviar cotización
                                <img :src="require('@/assets/images/app/send-quote.svg')
                                  " alt="" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="visible-mobile">
                        <div class="card card-info" v-if="selectedOption">
                          <div class="rememberme card-body">
                            <!-- <h4 class="text-center">Recuerda que:</h4>
                            <div class="card-info__item">
                              <img
                                :src="
                                  require('@/assets/images/app/shield-user.png')
                                "
                                alt=""
                              />
                              <span
                                >Tu ahorro incluye un seguro de vida por
                                S/25,000 para proteger a los que más amas</span
                              >
                            </div> -->
                            <div class="visible-mobile">
                              <a class="btn btn-wapp" target="_blank" href="tel:016149288">
                                <img :src="require('@/assets/images/app/newWpp.png')
                                  " alt="" width="160" loading="lazy" />
                                <span>Quiero comunicarme con un asesor</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="Myplan pt-2 col-md-4 col-sm-4 col-12">
                      <div class="hidden-mobile">
                        <div class="card card-plan" v-if="selectedOption">
                          <h5 class="simulator text-center">Mi plan</h5>
                          <div class="card-body">
                            <div class="card-plan__item">
                              <span>Mi aporte total</span>
                              <b>S/ {{ formatNumber(selectedOption.saved) }}</b>
                            </div>
                            <div class="card-plan__item">
                              <span>Mi ganancia</span>
                              <b>S/ {{ formatNumber(selectedOption.won) }}</b>
                            </div>
                            <div class="card-plan__item">
                              <span>Devolución total</span>
                              <b>S/ {{ formatNumber(selectedOption.amount) }}</b>
                            </div>
                          </div>
                          <div class="card-footer text-center">
                            Mi TREA es:
                            <div class="card-footer__interest text-center">
                              {{ selectedOption.tea }}%
                            </div>
                            <span class="card-footer__text text-center d-block">
                              Aprovecha esta SUPER tasa <br />
                              ahorrando DE A POCOS cada mes
                            </span>
                          </div>

                          <div class="Pinkbtn card-button text-center form-group mt-3 mb-3">
                            <button class="btn btn-pink btn-send" @click="setOption(selectedOption)">
                              Continuar
                            </button>
                          </div>
                          <div class="card-plan__quote-btn text-center form-group">
                            <button class="btn btn-outline-main btn-quote" type="button" @click="openQuoteModal()" v-b-modal="'modal-quote'">
                              Enviar cotización
                              <img :src="require('@/assets/images/app/send-quote.svg')
                                " alt="" />
                            </button>
                          </div>
                          <div>
<!--                            <b-modal id="modal-1" title="BootstrapVue">-->
<!--                              <p class="my-4">Hello from modal!</p>-->
<!--                            </b-modal>-->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="plan-detail" v-if="selectedOption && false">
                    <div class="row justify-content-center">
                      <div class="col-md-8 col-sm-8 col-12">
                        <div class="card">
                          <div class="card-body">
                            <div class="plan-detail__info duration">
                              <div class="plan-detail__info__description">
                                S/ {{ formatNumber(selectedOption.saved) }}
                              </div>
                              <div class="plan-detail__info__label">
                                Ahorros reales
                              </div>
                            </div>
                            <span> + </span>
                            <div class="plan-detail__info total-amount">
                              <div class="plan-detail__info__description">
                                S/ {{ formatNumber(selectedOption.won) }}
                              </div>
                              <div class="plan-detail__info__label">
                                Rentabilidad
                              </div>
                            </div>
                            <span> = </span>
                            <div class="plan-detail__info breakdown">
                              <div class="plan-detail__info__description">
                                <b>S/
                                  {{ formatNumber(selectedOption.amount) }}</b>
                              </div>
                              <div class="plan-detail__info__label">
                                Meta de ahorro
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="plan-selection" v-if="selectedOption && false">
                    <div class="row justify-content-center">
                      <div class="col-md-8 col-sm-8 col-12">
                        <div class="plan-selection__amount">
                          <div class="label">
                            Al término de {{ selectedOption.duration }} años,
                            obtendrás (rentabilidad garantizada):
                          </div>
                          <div class="amount">
                            <b>S/ {{ formatNumber(selectedOption.amount) }}</b>
                            <span>
                              <span class="tea">{{ selectedOption.tea }}%</span>
                              <br />
                              (TEA referencial)
                            </span>
                          </div>
                        </div>
                        <div class="plan-selection__actions">
                          <button class="btn btn-pink" @click="setOption(selectedOption)">
                            ¡Lo quiero!
                          </button>
                          <button class="btn btn-quote" @click="openQuoteModal()">
                            Enviar cotización
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="currentStep.key === 'payment'">
                  <div class="finalstep">
                    <div class="row justify-content-center">
                      <div class="hidden-mobile">
                        <div class="stepthree mb-3">
                          <span class="">
                            ¡Estás a solo un paso de construir tu meta!
                          </span>
                        </div>
                      </div>

                      <div class="col-md-12 col-sm-12 col-12 mt-2">
                        <form action="">
                          <div class="row justify-content-between">
                            <div class="visible-mobile">
                              <div class="col-md-6 col-12">
                                <div class="summary">
                                  <div class="summary__section">
                                    <div class="summary__section__label text-main mb-2">
                                      Resumen de pago
                                      <button @click="awesome = !awesome" type="button">
                                        <p v-if="awesome">
                                          <i class="fas fa-chevron-down"></i>
                                        </p>
                                        <p v-if="!awesome">
                                          <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                        </p>
                                      </button>
                                    </div>
                                    <div>
                                      <div class="summary__section__detail">
                                        <span>Pago mensual:</span>
                                        <b>S/ {{ formatNumber(goal.amount) }}</b>
                                      </div>
                                      <div class="summary__section__detail">
                                        <span>Per&iacute;odo:</span>
                                        <b>{{
                                          selectedOption.duration
                                        }}
                                          a&ntilde;os</b>
                                      </div>
                                    </div>
                                    <div v-if="!awesome">
                                      <!-- <div class="summary__section__detail">
                                                                                <span>Pago mensual:</span>
                                                                                <b>S/ {{ formatNumber(goal.amount)
                                                                                }}</b>
                                                                            </div> -->
                                      <!-- <div class="summary__section__detail">
                                                                                <span>Per&iacute;odo:</span>
                                                                                <b>{{
                                                                                        selectedOption.duration
                                                                                }}
                                                                                    a&ntilde;os</b>
                                                                            </div> -->
                                      <div class="summary__section__detail">
                                        <span>Tu 2da fecha de pago:</span>
                                        <span>{{ nextPaymentDate }}</span>
                                      </div>
                                      <div class="summary__section__detail">
                                        <span>Ganancia:</span>
                                        S/
                                        {{ formatNumber(selectedOption.won) }}
                                      </div>
                                      <div class="summary__section__detail">
                                        <span>Monto de cobertura:</span>
                                        S/ {{ formatNumber(goal.coverage) }}
                                      </div>
                                      <div class="summary__section__infouser mb-2">
                                        <span>Datos del Titular</span>
                                      </div>
                                      <div class="summary__section__detail">
                                        <span class="text-upper text-uppercase">{{
                                          userInfo.identificationType
                                        }}:</span>
                                        {{ userInfo.identificationNumber }}
                                      </div>
                                      <div class="summary__section__detail">
                                        <span>Nombre:</span>
                                        {{ payment.firstName }}
                                      </div>
                                      <div class="summary__section__detail">
                                        <span></span>
                                        {{ payment.lastName }}
                                        {{ payment.secondLastName }}
                                      </div>
                                      <div class="summary__section__detail">
                                        <span>Fecha de Nacimiento:</span>
                                        {{ userInfo.inputDob }}
                                      </div>
                                      <div class="summary__section__detail">
                                        <span>Género:</span>
                                        <span v-if="userInfo.gender === 'M'">Masculino</span>
                                        <span v-if="userInfo.gender === 'F'">Femenino</span>
                                      </div>
                                      <div class="summary__section__detail">
                                        <span>Celular:</span>
                                        {{ userInfo.phone }}
                                      </div>
                                      <div class="summary__section__detail">
                                        <span>Correo:</span>
                                        <span>
                                          {{ userInfo.email }}
                                        </span>
                                      </div>

                                      <div class="summary__info">
                                        <div class="summary__section__detail">
                                          <span class="txt w-100 text-center">
                                            Enviaremos el contrato a tu correo
                                            con esta información detallada.
                                          </span>
                                        </div>
                                        <div class="summary__section__detail">
                                          <small class="text-center d-block mb-2">
                                            <span>Puedes modificar los
                                              beneficiarios de tu seguro de vida
                                              enviando un correo a
                                            </span>
                                            <a href="mailto:rumbo@interseguro.com.pe">rumbo@interseguro.com.pe</a>
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!--CARD 1 ESCRITORIO-->
                            <div class="titular-dates col-md-6 col-12">
                              <!-- Payment -->
                              <div class="titular-dates__form card card-form">
                                <div class="card__title text-center">
                                  <span>Datos del Titular</span>
                                </div>
                                <div class="card-body">
                                  <div class="cardPay">
                                    <form action="">
                                      <!-- User -->
                                      <div class="formUser row">
                                        <div class="col-md-12 col-sm-12 col-12">
                                          <div class="form-group">
                                            <input type="text" class="form-control" placeholder="Nombres"
                                              :disabled="flags.searching" v-model="this.v$.payment.firstName.$model
                                                " @keydown="
    validateInput(
      $event,
      /^[a-zA-Z\s]*$/
    )
    " />
                                            <small>Por favor ingresa tu
                                              nombre</small>
                                          </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12 col-12 lastname">
                                          <div class="form-group">
                                            <input type="text" class="form-control" placeholder="Apellido paterno"
                                              :disabled="flags.searching" v-model="this.v$.payment.lastName.$model
                                                " @keydown="
    validateInput(
      $event,
      /^[a-zA-Z\s]*$/
    )
    " />
                                            <small>Por favor ingresa tu apellido
                                              paterno</small>
                                          </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12 col-12 motherln">
                                          <div class="form-group">
                                            <input type="text" class="form-control" placeholder="Apellido materno"
                                              :disabled="flags.searching" v-model="this.v$.payment.secondLastName
                                                .$model
                                                " @keydown="
    validateInput(
      $event,
      /^[a-zA-Z\s]*$/
    )
    " />
                                            <small>Por favor ingresa tu apellido
                                              materno</small>
                                          </div>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>

                              <div class="titular-dates__form-card card card-form">
                                <div class="PayCard card-body">
                                  <div class="visible-mobile">
                                    <div class="text-center mt-4 mb-4">
                                      <span>Aceptamos todas las tarjetas:</span>
                                      <div class="payments-cards text-center">
                                        <div class="card-brands mt-4">
                                          <img :src="require('@/assets/images/app/card-brands.png')
                                            " alt="" class="input-icon-left" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="hidden-mobile">
                                    <div class="payments-cards text-center mt-3 mb-4">
                                      <span>Aceptamos todas las tarjetas:</span>
                                      <div class="card-brands mt-4">
                                        <img :src="require('@/assets/images/app/card-brands.png')
                                          " alt="" class="input-icon-left" />
                                      </div>
                                    </div>
                                  </div>

                                  <div class="cardPays">
                                    <form action="">
                                      <div class="form-group d-none">
                                        <input type="text" class="form-control" v-model="this.v$.payment.placeholder.$model
                                          " />
                                        <input type="hidden" class="form-control" v-model="this.v$.payment.email.$model"
                                          data-culqi="card[email]" id="card[email]" />
                                        <label for="">Nombres</label>
                                        <small>Por favor ingresa el titular de la
                                          tarjeta</small>
                                      </div>
                                      <div class="cardPays__form form-group card-form mb-0">
                                        <div class="row">
                                          <div class="col-md-12 col-sm-12 col-12" :class="{
                                            invalid:
                                              this.v$.payment.creditCardNumber
                                                .$error,
                                          }">
                                            <div class="form-group">
                                              <img :src="require('@/assets/images/app/Trazado14308.svg')
                                                " v-if="payment.creditCardType === ''
    " alt="" class="input-icon-left" />
                                              <img :src="require('@/assets/images/app/visa.svg')
                                                " v-if="payment.creditCardType ===
    'VISA'
    " alt="" class="input-card" />
                                              <img :src="require('@/assets/images/app/mc.svg')
                                                " v-if="payment.creditCardType ===
    'MASTERCARD'
    " alt="" class="input-card" />
                                              <img :src="require('@/assets/images/app/diners.svg')
                                                " v-if="payment.creditCardType ===
    'DINERS'
    " alt="" class="input-card" />
                                              <img :src="require('@/assets/images/app/amex.svg')
                                                " v-if="payment.creditCardType ===
    'AMEX'
    " alt="" class="input-card" />
                                              <input type="text" class="form-control cc-input"
                                                placeholder="Número de tarjeta" data-culqi="card[number]"
                                                id="card[number]" v-mask="'#### #### #### ####'" v-model="this.v$.payment
                                                  .creditCardNumber.$model
                                                  " @keyup="validateCreditCard()" @change="savePaymentEvent()" />
                                              <small>Por favor ingresa el
                                                n&uacute;mero de tu
                                                tarjeta</small>
                                              <img v-if="payment.validCard" :src="require('@/assets/images/app/check-color.svg')
                                                " class="valid-card-icon" alt="" />
                                            </div>
                                          </div>
                                          <div class="col-md-6 col-sm-6 col-6">
                                            <div class="form-group" :class="{
                                              invalid:
                                                this.v$.payment.expirationDate
                                                  .$error ||
                                                this.flags
                                                  .invalidExpirationDate,
                                            }">
                                              <img :src="require('@/assets/images/app/img1.svg')
                                                " alt="" class="input-icon-left" />
                                              <input type="text" class="form-control" placeholder="MM/AA" maxlength="5"
                                                v-model="this.v$.payment.expirationDate
                                                  .$model
                                                  " v-mask="'##/##'" @change="setExpirationDate()" @keydown="
    validateInput($event, /^\d+$/)
    " />
                                              <small>Por favor ingresa una fecha de
                                                expiraci&oacute;n
                                                v&aacute;lida</small>
                                              <input type="hidden" size="2" v-model="this.v$.payment.month.$model
                                                " data-culqi="card[exp_month]" id="card[exp_month]" />
                                              <input type="hidden" size="4" v-model="this.v$.payment.year.$model
                                                " data-culqi="card[exp_year]" id="card[exp_year]" />
                                            </div>
                                          </div>
                                          <div class="col-md-6 col-sm-6 col-6">
                                            <div class="form-group">
                                              <img :src="require('@/assets/images/app/lock.svg')
                                                " alt="" class="input-icon-left" />
                                              <input type="text" class="form-control" placeholder="CVV" maxlength="5"
                                                v-model="this.v$.payment.maskedCvv
                                                  .$model
                                                  " @change="
    maskCvv();
  savePaymentEvent();
  " @keydown="
  validateInput($event, /^\d+$/)
  " />
                                              <small>Por favor ingresa el
                                                c&oacute;digo CVV</small>
                                              <input type="hidden" size="4" v-model="this.v$.payment.cvv.$model
                                                " data-culqi="card[cvv]" id="card[cvv]" />
                                            </div>
                                          </div>
                                          <template v-if="existingUser">
                                            <div class="col-md col-sm-6 col-12">
                                              <div class="form-group" :class="{
                                                invalid:
                                                  this.v$.payment.email
                                                    .$error,
                                              }">
                                                <input type="text" class="form-control" placeholder="Correo electrónico"
                                                  :disabled="flags.searching" v-model="this.v$.payment.email.$model
                                                    " @change="
    updateUserInfo('email')
    " data-culqi="card[email]" id="card[email]" />
                                                <small>Por favor ingresa tu correo
                                                  electrónico</small>
                                              </div>
                                            </div>
                                            <div class="col-md col-sm-6 col-12">
                                              <div class="form-group" :class="{
                                                invalid:
                                                  this.v$.payment.phone
                                                    .$error,
                                              }">
                                                <input type="text" class="form-control" v-model="this.v$.payment.phone.$model
                                                  " @change="
    updateUserInfo('phone')
    " maxlength="9" placeholder="Número de celular" data-culqi="card[phone]" id="card[phone]" />
                                                <small>Por favor ingresa tu número
                                                  de celular</small>
                                              </div>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                      <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                          <input type="checkbox" class="custom-control-input" id="customCheckDisabled2"
                                            v-model="automaticDebit" />
                                          <label class="custom-control-label" for="customCheckDisabled2">
                                            Deseo afiliarme al débito automático
                                            <span></span>
                                            <br />
                                            <span class="text-main d-block" v-if="!automaticDebit">¿Estás seguro? ¡Los
                                              clientes que
                                              usan afiliación automática llegan
                                              a sus objetivos de ahorro 3 veces
                                              más rápido!</span>
                                          </label>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                              <div class="payment-footer pl-0 pr-0">
                                <div class="hidden-mobile">
                                  <div class="backup">
                                    <img :src="require('@/assets/images/app/card-lock.png')
                                      " alt="" class="input-icon-left" />
                                    <span>
                                      <b>Tu compra es 100% segura.</b> <br />
                                      Somos parte del grupo Intercorp.
                                    </span>
                                  </div>
                                </div>

                                <div class="visible-mobile">
                                  <div class="backup">
                                    <img :src="require('@/assets/images/app/card-lock.png')
                                      " alt="" class="input-icon-left" />
                                    <span>
                                      <b>Tu compra es 100% segura.</b> <br />
                                      Somos parte del grupo Intercorp.
                                    </span>
                                  </div>
                                </div>

                                <div class="visible-mobile">
                                  <div class="form-group mt-2 mb-0">
                                    <button type="button" class="btn btn-pink btn-send" @click="placeOrder()"
                                      :disabled="flags.paying">
                                      <span v-if="!flags.paying">Pagar</span>
                                      <i class="fas fa-circle-notch fa-spin" v-if="flags.paying"></i>
                                    </button>
                                  </div>
                                  <div class="policies mt-2 mb-2">
                                    Al continuar acepto las
                                    <a v-b-modal.modal-policies>Condiciones y exclusiones</a>
                                    de la póliza. <br />
                                    Autorizo el envío de póliza electrónica y
                                    comunicaciones de Interseguro a mi correo.
                                  </div>
                                  <div class="Copyright mt-5 mb-2">
                                    <span>Copyright © 2020 Interseguro. Todos los
                                      derechos reservados</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!--CARD RESUMEN PAGO DESKTOP-->
                            <div class="col-md-5 col-12">
                              <div class="hidden-mobile">
                                <div class="summary">
                                  <div class="summary__section">
                                    <div class="summary__section__label text-main mb-2">
                                      Resumen de pago
                                    </div>
                                    <div class="summary__section__detail">
                                      <span>Pago mensual:</span>
                                      <b>S/ {{ formatNumber(goal.amount) }}</b>
                                    </div>
                                    <div class="summary__section__detail">
                                      <span>Per&iacute;odo:</span>
                                      <b>{{
                                        selectedOption.duration
                                      }}
                                        a&ntilde;os</b>
                                    </div>
                                    <div class="summary__section__detail">
                                      <span>Tu 2da fecha de pago:</span>
                                      <span>{{ nextPaymentDate }}</span>
                                    </div>
                                    <div class="summary__section__detail">
                                      <span>Ganancia:</span>
                                      S/
                                      {{ formatNumber(selectedOption.won) }}
                                    </div>
                                    <div class="summary__section__detail">
                                      <span>Monto de cobertura:</span>
                                      S/ {{ formatNumber(goal.coverage) }}
                                    </div>
                                    <div class="summary__section__detail">
                                      <!-- <small class="d-block w-100">
                                                                              Tus beneficiarios serán tu herederos
                                                                              legales. <br />
                                                                              Puedes hacer modificaciones luego de la
                                                                              compra en <br />
                                                                              nuestra plataforma digital.
                                                                          </small> -->
                                    </div>
                                    <div class="summary__section__infouser mb-4">
                                      <span>Datos del Titular</span>
                                    </div>
                                    <div class="summary__section__detail">
                                      <span class="text-upper text-uppercase">{{
                                        userInfo.identificationType
                                      }}:</span>
                                      {{ userInfo.identificationNumber }}
                                    </div>
                                    <div class="summary__section__detail">
                                      <span>Nombre:</span>
                                      {{ payment.firstName }}
                                    </div>
                                    <div class="summary__section__detail">
                                      <span></span>
                                      {{ payment.lastName }}
                                      {{ payment.secondLastName }}
                                    </div>
                                    <div class="summary__section__detail">
                                      <span>Fecha de Nacimiento:</span>
                                      {{ userInfo.inputDob }}
                                    </div>

                                    <div class="summary__section__detail">
                                      <span>Género:</span>
                                      <span v-if="userInfo.gender === 'M'">Masculino</span>
                                      <span v-if="userInfo.gender === 'F'">Femenino</span>
                                    </div>

                                    <div class="summary__section__detail">
                                      <span>Celular:</span>
                                      {{ userInfo.phone }}
                                    </div>
                                    <div class="summary__section__detail">
                                      <span>Correo:</span>
                                      <span>{{ userInfo.email }}</span>
                                    </div>
                                    <div class="summary__info">
                                      <div class="summary__section__detail">
                                        <span class="txt w-100 text-center">
                                          Enviaremos el contrato a tu correo con
                                          esta información detallada.
                                        </span>
                                      </div>
                                      <div class="summary__section__detail">
                                        <small class="txtblock d-block w-100">
                                          <span>Puedes modificar los beneficiarios
                                            de tu seguro de vida enviando un correo a:
                                          </span>
                                          <!-- <span>rumbo@interseguro.com.pe</span> -->
                                          <a href="mailto:rumbo@interseguro.com.pe">rumbo@interseguro.com.pe</a>
                                        </small>
                                      </div>
                                      <div class="form-group mt-2 mb-0">
                                        <button type="button" class="btn btn-pink btn-send" @click="placeOrder()"
                                          :disabled="flags.paying">
                                          <span v-if="!flags.paying">Pagar</span>
                                          <i class="fas fa-circle-notch fa-spin" v-if="flags.paying"></i>
                                        </button>
                                      </div>
                                      <div class="policies mt-2">
                                        Al continuar acepto las
                                        <a v-b-modal.modal-policies>Condiciones y exclusiones</a>
                                        de la póliza. <br />
                                        Autorizo el envío de póliza electrónica
                                        y comunicaciones de Interseguro a mi
                                        correo.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </template>
              </template>

              <!-- v-if="flags.paymentCompleted" -->
              <div v-if="flags.paymentCompleted">
                <div class="success">
                  <h2>¡Felicidades!</h2>
                  <h3>
                    Tu póliza <b>{{ policyNumber }}</b> ha sido creada.
                  </h3>
                  <h3>Ya eres parte de rumbo</h3>
                  <p>
                    Cada vez que intentes ingresar a tu <b>Zona Cliente</b> con
                    tu DNI, te enviaremos una clave dinámica a tu correo que
                    será válido por 5 minutos, para tu seguridad.
                  </p>
                  <div class="actions text-center justify-content-center">
                    <button class="btn btn-pink" v-b-modal.modal-login>
                      Zona Cliente
                    </button>
                    <button class="btn btn-outline-main" @click="goHome()">
                      Salir
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a class="chat-button phone" id="chatButton" target="_blank" href="tel:016149288" @click="openWapp()">
        <img :src="require('@/assets/images/app/newWpp.png')" alt="" width="160" loading="lazy" />
        <div class="chat-button__label visible-mobile">
          Llámanos
        </div>
        <div class="chat-button__label hidden-mobile">
          Llámanos al (01) 614-9288
        </div>
      </a>
      <a class="chat-button hidden-mobile" id="chatButton" target="_blank"
        href="https://api.whatsapp.com/send?phone=51946523076&text=Hola%2C%20Rumbo.%20%C2%A1Deseo%20m%C3%A1s%20informaci%C3%B3n!"
        @click="openWapp()">
        <img :src="require('@/assets/images/app/wapp-chat.svg')" alt="" width="160" loading="lazy" />
        <div class="chat-button__label">
          Comunícate con un asesor vía WhatsApp
        </div>
      </a>
    </div>
    <b-modal id="modal-loading" centered hide-backdrop size="sm" modal-class="modal-loading" ref="modal-loading">
      <img :src="require('@/assets/images/app/clock.gif')" alt="" />
      <h3>Tu pago se est&aacute; procesando</h3>
      <h4>Espera unos minutos por favor</h4>
    </b-modal>

    <b-modal id="modal-conditions" ok-only ok-title="Entendido" centered size="lg" modal-class="modal-conditions"
      title=" ">
      <b-card-text>
        <div class="general-conditions">
          <h3>Condiciones generales</h3>
          <p>
            Para acceder a las condiciones generales y particulares de la
            póliza, haz clic en los siguientes enlaces:
            <a target="_blank"
              href="https://2xbftadhnj7fo.blob.core.windows.net/public/Condicionado_General.pdf">Condicionado General</a>
            <a target="_blank"
              href="https://2xbftadhnj7fo.blob.core.windows.net/public/Condicionado_Particular.pdf">Condicionado
              Particular</a>
          </p>
          <h3>Exclusiones</h3>
          <div class="row">
            <div class="col-6">
              <p>La cobertura escogida incluye:</p>
              <ul>
                <li>Fallecimiento por muerte natural.</li>
              </ul>
            </div>
            <div class="col-6">
              <p>La cobertura escogida NO incluye:</p>
              <ul>
                <li>Fallecimiento por muerte accidental.</li>
                <li>Enfermedades graves.</li>
                <li>Invalidez total y permanente.</li>
              </ul>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-modal>

    <b-modal id="comunications-policies-modal" ok-only ok-title="Entendido" centered size="lg"
      modal-class="modal-conditions" title="Política de Comunicaciones" ref="comunications-policies-modal">
      <b-card-text>
        <div class="general-conditions">
          <p>
            Usted puede brindar su consentimiento para que INTERSEGURO, las
            <a href="https://www.interseguro.pe/soat/archivo/Pol%C3%ADtica_de_Privacidad_de_Interseguro-Anexo_1.pdf"
              target="_blank">empresas del Grupo Intercorp y/o sus socios comerciales:</a>
          </p>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="chkbxPolicies1"
              v-model="comunicationPolicies.profile" />
            <label class="custom-control-label" for="chkbxPolicies1">Realicen estudios de mercado y perfiles de compra.
            </label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="chkbxPolicies2"
              v-model="comunicationPolicies.offers" />
            <label class="custom-control-label" for="chkbxPolicies2">Envíen publicidad, promociones y ofertas de los
              productos y/o
              servicios.
            </label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="chkbxPolicies3" :checked="comunicationPolicies.profile && comunicationPolicies.offers
              " v-model="comunicationPolicies.all" @change="changeComunicationPolicyContiion()" />
            <label class="custom-control-label" for="chkbxPolicies3">Sí a todo.
            </label>
          </div>
        </div>
      </b-card-text>
    </b-modal>

    <b-modal id="modal-terms" ok-only ok-title="Entendido" centered size="lg" title="Declaración jurada del contratante">
      <b-card-text>
        <p>
          Declaro que tengo conocimiento y acepto las Condiciones Generales,
          Particulares, Especiales y Cláusulas Adicionales relacionadas con la
          Póliza de Seguros de Interseguro Compañía de Seguros.
        </p>
        <p>
          Certifico que las respuestas y declaraciones realizadas en este sitio
          web son verídicas y que se ajustan a la realidad y de no serlo,
          cualquier declaración falsa hecha por el Contratante, voluntaria o
          involuntariamente, invalida esta solicitud y libera de toda
          responsabilidad y compromiso indemnizatorio a Interseguro Compañía de
          Seguros, quedando el seguro emitido en virtud de esta solicitud nulo y
          sin efecto.
        </p>
        <p>
          El Contratante otorga su consentimiento para que su Póliza de seguro
          electrónica, endosos futuros, cartas y/u otra documentación, sean
          enviados vía correo electrónico desde el dominio @interseguro. Todas
          aquellos documentos y comunicaciones se entenderán por recibidos en la
          casilla de correo electrónica declarada por el Contratante, a través
          de la confirmación del servidor de destino. La póliza contendrá una
          firma digital y una contraseña de acceso para visualizar el documento,
          ello garantizará la autenticidad e integridad del documento, de
          acuerdo con lo estipulado en la Ley N° 27269 - Ley de Firmas y
          Certificados Digitales. Asimismo, declara conocer las medidas de
          seguridad que debe adoptar para la recepción de los citados
          documentos, las ventajas y riesgos asociados a esta modalidad de
          envío, garantiza haber suministrado un correo electrónico válido en la
          Solicitud de Seguro, el cual mantendrá activo y con espacio suficiente
          para recibir la Póliza y se comprometen a informar su nuevo correo
          electrónico, en caso sea dado de baja o desee modificar la cuenta de
          correo declarada.
        </p>
      </b-card-text>
    </b-modal>

    <b-modal id="modal-policies" ok-only ok-title="Cerrar" centered size="lg" title="POLÍTICA DE PRIVACIDAD">
      <b-card-text>
        <p>
          Sus datos personales serán utilizados por Interseguro Compañía de
          Seguros S.A. (<b>INTERSEGURO</b>) para las siguientes finalidades:
        </p>
        <ul>
          <li>Para la adquisición de productos de <b>INTERSEGURO</b></li>
          <li>
            Enviar documentos de contratación de productos de <b>INTERSEGURO</b>
          </li>
          <li>
            Realizar cotizaciones de productos de <b>INTERSEGURO</b> por
            solicitud del USUARIO
          </li>
        </ul>
        <p>
          Para mayor información puedes consultar la &nbsp;
          <a href="https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro-1810.pdf" target="_blank"
            class="text-main" style="text-decoration: underline">Pol&iacute;tica de privacidad</a>
        </p>
      </b-card-text>
    </b-modal>

    <b-modal id="modal-login" ok-only ok-title="Entendido" centered size="sm" modal-class="modal-login"
      title="Inicia sesión">
      <div class="quote-card">
        <form action="#" v-if="!flags.validateOtp">
          <div class="d-flex justify-content-start">
            <div class="form-group">
              <input type="radio" id="loginDni" name="client-doc" v-model="this.v$.login.identificationType.$model"
                checked />
              <label for="loginDni">DNI</label>
            </div>
            <div class="form-group">
              <input type="radio" name="client-doc" id="loginCe" v-model="this.v$.login.identificationType.$model" />
              <label for="loginCe">CE</label>
            </div>
          </div>
          <div class="form-group d-block" :class="{ invalid: this.v$.login.identificationNumber.$error }">
            <input type="text" placeholder="Digita tu número de documento" class="form-control"
              v-model="this.v$.login.identificationNumber.$model" />
            <div v-if="this.v$.login.identificationNumber.$error">
              <span :class="{ error: this.v$.login.identificationNumber.$error }">Ingrese un número de documento
                v&aacute;lido</span>
            </div>
          </div>
          <div class="form-group">
            <button type="submit" class="form-btn" @click="sendOtp()" :disabled="flags.logingIn">
              <span v-if="!flags.logingIn">Continuar</span>
              <i class="fas fa-circle-notch fa-spin" v-if="flags.logingIn"></i>
            </button>
          </div>
        </form>
        <form action="#" v-if="flags.validateOtp" @submit="validateOtp">
          <div class="form-group">
            <label label for="" style="position: initial">Ingresa el c&oacute;digo enviado al correo {{ otp.email
            }}</label>
          </div>
          <div class="form-group d-block" :class="{ invalid: this.v$.login.identificationNumber.$error }">
            <input type="text" placeholder="Codigo de autenticación" class="form-control"
              v-model="this.v$.otpCode.code.$model" />
            <div v-if="this.v$.userInfo.identificationNumber.$error && flags.showError
              ">
              <span :class="{ error: this.v$.login.identificationNumber.$error }">Ingrese un c&oacute;digo
                v&aacute;lido</span>
            </div>
          </div>
          <div class="form-group">
            <button type="submit" class="form-btn" :disabled="flags.logingIn">
              <span v-if="!flags.logingIn">Validar</span>
              <i class="fas fa-circle-notch fa-spin" v-if="flags.logingIn"></i>
            </button>
          </div>
        </form>
      </div>
      <!--
            <form class="modal-login__form" v-if="!flags.validateOtp">
                <div class="form-group">
                    <div class="btncustom custom-control custom-radio custom-control-inline">
                        <input type="radio" id="loginDni" name="customRadioInline1" class="custom-control-input"
                            value="dni" v-model="this.v$.login.identificationType.$model" />
                        <label class="custom-control-label" for="loginDni">DNI</label>
                    </div>
                    <div class="btncustom custom-control custom-radio custom-control-inline">
                        <input type="radio" id="loginCe" name="customRadioInline1" class="custom-control-input"
                            value="ce" v-model="this.v$.login.identificationType.$model" />
                        <label class="custom-control-label" for="loginCe">CE</label>
                    </div>
                </div>
                <div class="form-group" :class="{
                    invalid: this.v$.login.identificationNumber.$error,
                }">
                    <label class="text-uppercase">{{ login.identificationType }}</label>
                    <input type="text" class="form-control" v-model="this.v$.login.identificationNumber.$model" />
                    <small>Ingrese un n&uacute;mero de documento v&aacute;lido</small>
                </div>
                <div class="form-group">
                    <button class="btn btn-second" @click="sendOtp()" type="button" :disabled="flags.logingIn">
                        <span v-if="!flags.logingIn">Ingresar</span>
                        <i class="fas fa-circle-notch fa-spin" v-if="flags.logingIn"></i>
                    </button>
                </div>
            </form>
            <form class="modal-login__form" v-if="flags.validateOtp">
                <div class="form-group">
                    <label for="" style="color: #fff; position: initial">Ingresa el c&oacute;digo enviado al correo {{
                            otp.email
                    }}</label>
                </div>
                <div class="form-group" :class="{
                    invalid: this.v$.login.identificationNumber.$error,
                }">
                    <label class="text-uppercase">Codigo de autenticaci&oacute;n</label>
                    <input type="text" class="form-control" v-model="this.v$.otpCode.code.$model" />
                    <small>Ingrese un c&oacute;digo v&aacute;lido</small>
                </div>
                <div class="form-group">
                    <button class="btn btn-second" @click="validateOtp()" type="button" :disabled="flags.logingIn">
                        <span v-if="!flags.logingIn">Validar</span>
                        <i class="fas fa-circle-notch fa-spin" v-if="flags.logingIn"></i>
                    </button>
                </div>
            </form>-->
    </b-modal>

    <b-modal id="modal-quote" ok-only ok-title="Entendido" centered size="sm" modal-class="modal-login"
      title="Enviar cotización" ref="modal-quote">
      <form class="modal-login__form">
        <div class="form-group" :class="{
          invalid: this.v$.quote.email.$error,
        }">
          <input type="text" class="form-control" placeholder="Ingrese su Email" v-model="this.v$.quote.email.$model" />
          <small>Ingrese un email v&aacute;lido</small>
        </div>
        <div class="form-group mt-3">
          <button class="btn btn-pink" @click="sendQuote()" type="button" :disabled="flags.sendingQuote">
            <span v-if="!flags.sendingQuote">Enviar cotización</span>
            <i class="fas fa-circle-notch fa-spin" v-if="flags.sendingQuote"></i>
          </button>
        </div>
        <p v-if="this.flags.sendedQuote" class="mt-2 text-success">
          Cotizaci&oacute;n enviada, por favor revisa tu correo.
        </p>
      </form>
    </b-modal>

    <!-- tarjeta invalida -->
    <b-modal id="modal-error" ok-only ok-title="Entiendo" centered modal-class="modal-error" ref="modal-card-error">
      <div class="modal-error__header">
        <div class="modal-error__header__message">
          <span>Operación Denegada</span>
        </div>
        <div class="modal-error__img">
          <img :src="require('@/assets/images/app/error.svg')" alt="" />
        </div>
      </div>
      <div class="modal-error__head">
        <span>Por favor ingrese una tarjeta de cr&eacute;dito o d&eacute;bito
          v&aacute;lida</span>
        <div class="modal-error__head__btn">
          <button type="button" class="accept" @click="closeModal('modal-card-error')">
            Entendido
          </button>
        </div>
      </div>
    </b-modal>
    <!-- Error  -->
    <b-modal id="modal-error" ok-only ok-title="Entiendo" centered modal-class="modal-error" ref="modal-error">
      <div class="modal-error__header">
        <div class="modal-error__header__message">
          <span>Operación Denegada</span>
        </div>
        <div class="modal-error__img">
          <img :src="require('@/assets/images/app/error.svg')" alt="" />
        </div>
      </div>
      <div class="modal-error__head">
        <span v-if="errors.payment === ''">
          Se ha presentado un error en nuestro sistema. Intenta nuevamente o
          escríbenos a correo rumbo@interseguro.com.pe
        </span>
        <span v-if="errors.payment !== ''">
          {{ errors.payment }}
        </span>
        <div class="modal-error__head__btn">
          <button type="button" class="accept" @click="closeModal('modal-error')">
            Entendido
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-error" ok-only ok-title="Entiendo" centered modal-class="modal-error" ref="modal-error-client">
      <div class="modal-error__header">
        <div class="modal-error__header__message">
          <span>Operación Denegada</span>
        </div>
        <div class="modal-error__img">
          <img :src="require('@/assets/images/app/error.svg')" alt="" />
        </div>
      </div>
      <div class="modal-error__head">
        <span>
          Se ha presentado un error en nuestro sistema. {{ modalErrorClient }}
        </span>

        <div class="modal-error__head__btn">
          <button type="button" class="accept" @click="closeModal('modal-error-client')">
            Entendido
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-free-month" ok-only ok-title="Entiendo" centered size="lg" modal-class="modal-free-month"
      ref="modal-free-month">
      <div class="modal-free-month__head">
        ¡Este
        <img :src="require('@/assets/images/app/gift.svg')" alt="" /> espera por
        ti!
      </div>
      <div class="modal-free-month__countdown">
        <div class="time-box">
          <div class="time-box__time">{{ hours }}</div>
          <div class="time-box__label">Horas</div>
        </div>
        <div class="time-box">
          <div class="time-box__time">{{ minutes }}</div>
          <div class="time-box__label">Minutos</div>
        </div>
        <div class="time-box">
          <div class="time-box__time">
            {{ seconds < 10 ? "0" + seconds : seconds }} </div>
              <div class="time-box__label">Segundos</div>
          </div>
        </div>
        <div class="modal-free-month__content">
          <div class="modal-free-month__content__title">
            <div class="row">
              <div class="col-2">
                <div class="title-img">
                  <img :src="require('../../../src/assets/images/app/Group-2339.png')
                    " alt="" />
                </div>
              </div>
              <div class="col">
                <div class="title">
                  <div class="title__text">
                    <h4>Tu 2do mes</h4>
                    <h5>GRATIS*</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a :href="'https://wa.link/o1y194?utm_source=botmaker&utm_medium=whatsapp&utm_campaign=promocion_rumbo-botmaker-whatsapp-pf-on-rumbo-ahorro'"
            target="_blank" class="bullets">
            <div class="bullets__title">
              <!-- <img :src="require('../../../src/assets/images/app/pelota-roja.png')" alt="" /> -->
              <h4>¿Cómo obtener mi regalo?</h4>
              <!-- <img :src="require('../../../src/assets/images/app/trago.png')" alt="" /> -->
            </div>
            <div class="d-flex justify-content-center bullets__list">
              <ul>
                <li class="bullets__stepone">
                  <span>1</span>
                  <p>
                    Personaliza tu plan de ahorro en nuestro simulador en línea.
                  </p>
                </li>
                <li class="bullets__steptwo">
                  <span>2</span>
                  <p>
                    Afilia una tarjeta de banco de tu preferencia y realiza tu
                    pago.
                  </p>
                </li>
                <li class="bullets__stepthree">
                  <span>3</span>
                  <p>
                    Envíanos un pantallazo de la operación y tu N° de DNI <br />a
                    nuestro WhatsApp.
                    <img :src="require('@/assets/images/app/wapp-chat.svg')" alt="" />
                  </p>
                </li>
              </ul>
              <div class="bullets__list__img">
                <img :src="require('../../../src/assets/images/app/mano-cel.png')" alt="" />
              </div>
            </div>
          </a>
          <div class="modal-free-month__content__promo-wpp text-center">
            <span>*Un mes gratis por cliente, para aportes hasta S/400.</span>
          </div>
          <div class="action">
            <button class="btn btn-pink" @click="closeFreeMonthModal">
              Continuar
            </button>
          </div>
        </div>
    </b-modal>
  </div>
</template> 
  
  

  <!-- FUNCIONALITY -->
<script lang="ts">
import {
  BButton,
  BModal,
  BCardText,
  BCollapse,
  BCard,
  VBToggle,
  VBModal,
} from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
import es from "vuejs-datepicker/dist/locale/translations/es";
import gatewayService from "@/services/gateway-service";
// import VueSlider from "vue-slider-component";
import VueSlider from "vue-3-slider-component";
import "vue-slider-component/theme/antd.css";
// import {
//   required,
//   minLength,
//   maxLength,
//   email,
//   helpers,
//   numeric,
// } from "vuelidate/lib/validators";
import axios from "axios";
import valid from "card-validator";
import moment from "moment";
import "moment/locale/es";
import { mask, field, VueTheMask } from "vue-the-mask";
import { environment } from "../../environment/environment";
// import useValidate, { useVuelidate } from "@vuelidate/core";
import {useVuelidate} from "@vuelidate/core";
import {required, email, numeric, minValue, maxValue, minLength, maxLength, helpers} from "@vuelidate/validators";
import slider from "vue3-slider";
import { defineComponent } from "vue";
import trackingService from "../../services/tracking-service";

//
import Slider from "@vueform/slider";
import userService from "@/services/user-service";
import policyService from "@/services/policy-service";
import analyticsService from "@/services/analytics-service";
import analyicsService from "@/services/analytics-service";

export default defineComponent({
  components: {
    // Datepicker,
    BCardText,
    BButton,
    BCollapse,
    BCard,
    BModal,
    VueSlider,
    field,
    VueTheMask,
    Slider,
    VBToggle,
    "vue3-slider": slider,
  },
  directives: { mask, "b-modal": VBModal, "b-toggle": VBToggle },
  data() {
    return {
      modalErrorClient: "",
      tokenCulqi:"",
      basePath: "",
      // basePath: window["basePath"],
      v$: useVuelidate(),
      apiUrl: environment.api,
      isApiPlans: environment.isApiPlans,
      isApiQuote: environment.isApiQuote,
      isApiEmission: environment.isApiEmission,
      isApiTermConditions: environment.isApiTermConditions,
      uuid: this.generateUUID(),
      steps: [
        {
          order: 1,
          key: "userInfo",
          completed: true,
          active: true,
          label: "Completa",
          title: "Ingresa tus datos personales",
          description:
            "Con solo estos datos podrás personalizar el mejor plan de ahorros para ti",
        },
        {
          order: 1,
          key: "goal",
          completed: false,
          active: true,
          label: "Cotiza",
          title: "Programa tus ahorros",
          description: "Ahora, elige cuánto ahorrar y por cuánto tiempo",
        },
        {
          order: 2,
          key: "payment",
          completed: false,
          active: false,
          label: "Paga",
          title: "Finaliza tu compra",
          description: "¡Estás a solo un paso de construir tu meta!",
        },
      ],
      userInfo: {
        email: "",
        firstName: "",
        lastName: "",
        secondLastName: "",
        dateOfBirth: "",
        inputDob: "",
        gender: "--",
        phone: "",
        identificationNumber: "",
        identificationType: "dni",
        fullName: "",
      },
      basicInfo: {
        dateOfBirth: "",
        gender: "",
      },
      login: {
        identificationNumber: "",
        identificationType: "dni",
      },
      otpCode: {
        code: "",
      },
      goal: {
        age: 0,
        amount: 300,
        coverage: 25000,
        period: 1,
        option: null,
      },
      payment: {
        firstName: "",
        lastName: "",
        secondLastName: "",
        creditCardNumber: "",
        creditCardType: "",
        validCard: false,
        placeholder: "",
        expirationDate: "",
        year: "",
        month: "",
        maskedCvv: "",
        cvv: "",
        invoice: false,
        email: "",
        phone: "",
      },
      quote: {
        email: "",
      },
      options: [],
      allOptions: [],
      periods: {
        1: {
          id: 1,
          name: "Mensual",
        },
        3: {
          id: 3,
          name: "Trimestral",
        },
        12: {
          id: 12,
          name: "Anual",
        },
      },
      coverages: {
        1: {
          id: 25000,
          name: "S/ 25,000",
        },
        2: {
          id: 50000,
          name: "S/ 50,000",
        },
        3: {
          id: 75000,
          name: "S/ 75,000",
        },
      },
      currentStep: {
        key: "userInfo",
        completed: false,
        active: false,
        label: "Datos personales",
        title: "Ingresa tus datos personales",
        description:
          "Con solo estos datos podrás personalizar el mejor plan de ahorros para ti",
      },
      amountSlider: {
        min: 160,
        max: 700,
        interval: 20,
      },
      flags: {
        invalidCard: false,
        paymentCompleted: false,
        disabledInputs: true,
        olderThanAllowedAge: false,
        validateOtp: false,
        logingIn: false,
        paying: false,
        searching: false,
        showSeeMore: false,
        loadingPlans: false,
        disabledDateOfBirth: true,
        disabledSecondLastName: true,
        disabledLastName: true,
        disabledName: true,
        disabledGender: true,
        sendingQuote: false,
        invalidAge: false,
        invalidDocument: false,
        disableForms: false,
        errorPolicy: false,
      },
      errors: {
        marketingEmails: false,
        payment:
          "Tu método de pago fue rechazado. Por favor, confirma que los datos sean válidos o ingresa otra tarjeta.",
      },
      planVisibility: "d-none",
      es: es,
      disabledDates: null,
      marketingEmails: false,
      marketingData: false,
      automaticDebit: true,
      otp: null,
      nextPaymentDate: null,
      requests: [],
      request: null,
      selectedOption: null,
      existingUser: true,
      documentLength: 8,
      countdownInterval: null,
      hours: 23,
      minutes: 59,
      seconds: 59,
      freeMonthModal: false,
      mask: "#XSAa",
      masked: false,
      hashId: "",
      awesome: false,
      policyNumber: "",
      policies: false,
      comunicationPolicies: {
        profile: false,
        offers: false,
        all: false,
      },
    };
  },
  validations: function () {
    return {
      userInfo: {
        firstName: { required },
        lastName: { required },
        secondLastName: { required },
        email: {required,regex: helpers.regex(/^[a-zA-Z0-9*._-]+@[a-zA-Z0-9*_-]+(\.[a-zA-Z0-9*_-]+)+$/)},
        // email: {required},

        phone: { minLength: minLength(9), required },
        identificationType: { required },
        identificationNumber: {
          required,
          numeric,
          minLength: minLength(this.documentLength),
          maxLength: maxLength(this.documentLength),
        },
        dateOfBirth: { required },
        inputDob: { required },
        gender: { required, maxLength: maxLength(1) },
      },
      basicInfo: {
        dateOfBirth: { required },
        gender: { required },
      },
      login: {
        identificationType: { required },
        identificationNumber: { required, numeric },
      },
      quote: {
        email: {required,regex: helpers.regex(/^[a-zA-Z0-9*._-]+@[a-zA-Z0-9*_-]+(\.[a-zA-Z0-9*_-]+)+$/)},
      },
      otpCode: {
        code: { required, numeric },
      },
      goal: {
        amount: { required },
        coverage: { required },
        period: { required },
      },
      payment: {
        creditCardNumber: { required },
        creditCardType: {},
        installments: {},
        placeholder: {},
        firstName: { required },
        lastName: { required },
        secondLastName: { required },
        expirationDate: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(5),
        },
        year: {},
        month: {},
        maskedCvv: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(4),
        },
        cvv: {},
        invoice: {},
        email: {required,regex: helpers.regex(/^[a-zA-Z0-9*._-]+@[a-zA-Z0-9*_-]+(\.[a-zA-Z0-9*_-]+)+$/)},
        // email: { required, isEmailWithAsterisk: helpers.regex('isEmailWithAsterisk', /^[^\s@*]+(\*[^\s@*]+)*@[^\s@*]+(\*[^\s@*]+)*\.[^\s@*]{2,}$/)},
        phone: { required},
      },
    };
  },
  created() {
    this.init();
    window.addEventListener("scroll", this.onWindowScroll);
    window.addEventListener("mousemove", this.onMouseMove);
  },
  mounted() { },
  watch: {},
  methods: {
    init() {
      // let isClient = JSON.parse(window.localStorage.getItem("__isClient__") || '{}');
      this.loadLeadData();
      this.getDocumentNumber();

      // if (isClient){
        this.loadUser(false);
      // }
      this.getInitDate();
      this.initCulqui();
      this.saveInitDatalayerEvent();

      let width = window.innerWidth;
      if (width < 480) {
        this.awesome = true;
      }
    },
    loadLeadData() {
      let leadData: any = JSON.parse(
        window.localStorage.getItem("__quoteLeadDetail__")
      );

      if (leadData && leadData.paymentAmount) {
        this.goal.amount = leadData.paymentAmount;
      }
    },
    initCountdown() {
      let _context = this;
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }

      _context.hours = 23;
      _context.minutes = 59;
      _context.seconds = 59;

      this.countdownInterval = setInterval(() => {
        _context.seconds--;

        if (_context.seconds === 0) {
          _context.seconds = 59;
          _context.minutes--;
        }

        if (_context.minutes === 0) {
          _context.minutes = 59;
          _context.hours--;
        }
      }, 1000);
    },
    saveInitDatalayerEvent() {
      this.saveDataLayerEvent({
        event: "virtualPageView",
        pageTitle: "Rumbo | Paso 3",
        pageUrl: "/seguro-de-vida/rumbo/paso/3/",
      });
    },
    initCulqui() {
      var _window: any = window;

      _window["Culqi"].publicKey = environment.culquiToken;
      _window["Culqi"].init();
    },
    getInitDate() {
      let date = moment(new Date());
      let initDate = date.subtract(18, "years");

      this.disabledDates = {
        from: initDate.toDate(),
        openDate: initDate.toDate(),
      };
    },
    generateNextPaymentDate() {
      moment.locale("es");

      let date = moment();
      let incremental = 0;

      if (date.date() == 1) {
        date = moment().add(this.goal.period, "months");
      } else {
        date = moment().add(this.goal.period + 1, "months");
      }
      let dateString = "";
      dateString = date.format("[1] [de] MMMM [de] YYYY");

      this.nextPaymentDate = dateString;
    },
    getDocumentNumber() {
      const documentType = window.localStorage.getItem("__quoteDocumentType__");
      const documentNumber = window.localStorage.getItem(
        "__quoteDocumentNumber__"
      );

      this.userInfo.identificationType = documentType;
      this.userInfo.identificationNumber = documentNumber;

      if (documentType === "ce") {
        this.documentLength = 9;
      }
    },
    async loadUser(force: any) {
      this.hashId = window.localStorage.getItem("__hashiId__");
      if (this.userInfo.identificationNumber === "") return;

      try {
        let user = JSON.parse(window.localStorage.getItem("__quoteUser__"));

        if (!user && force) {
          this.flags.searching = true;
          var result = await axios.post(
            `${this.apiUrl}users/search?identificationType=${this.userInfo.identificationType}&identificationNumber=${this.userInfo.identificationNumber}`
          );
          if (result.data) {
            user = result.data;
          }
        }

        this.existingUser = false
        let queryParams = this.$route.query;

        if (queryParams && queryParams.document) {
          if (
            user.firstName &&
            user.firstName !== "" &&
            user.lastName &&
            user.lastName !== "" &&
            user.secondLastName &&
            user.secondLastName !== "" &&
            user.dateOfBirth &&
            user.dateOfBirth !== "" &&
            user.phone &&
            user.phone !== "" &&
            user.email &&
            user.email !== "" &&
            user.gender &&
            user.gender !== ""
          ) {
            if (queryParams.document == user.identificationNumber) {
              this.existingUser = true;
            }
          }
        }

        this.userInfo.firstName = user.firstName;
        this.userInfo.lastName = user.lastName;
        this.userInfo.secondLastName = user.secondLastName;
        this.userInfo.email = user.email;
        this.userInfo.phone = user.phone;
        this.userInfo.gender = user.gender ? user.gender : "--";

        this.payment.email = user.email;
        this.payment.phone = user.phone;

        this.quote.email = user.email;

        if (user.dateOfBirth && user.dateOfBirth !== "") {
          let date = user.dateOfBirth.split("-");
          this.userInfo.dateOfBirth = new Date(date[0], date[1] - 1, date[2]);
          this.userInfo.inputDob = `${date[2]}/${date[1]}/${date[0]}`;
          this.userInfo.inputDobBraze = `${date[0]}-${date[1]}-${date[2]}`;
          this.flags.disabledDateOfBirth = true;

          this.validateAllowedAge();

          if (this.flags.olderThanAllowedAge) {
            this.existingUser = false;
          }
        } else {
          this.userInfo.dateOfBirth = null;
          this.flags.disabledDateOfBirth = false;
        }

        if (this.existingUser) {
          this.currentStep = {
            key: "goal",
            completed: false,
            active: false,
            label: "Cotiza",
            title: "Programa tus ahorros",
            description: "Ahora, elige cuánto ahorrar y por cuánto tiempo",
          };

          this.steps[0].completed = true;
          this.steps[0].active = false;

          this.steps[1].completed = false;
          this.steps[1].active = true;

          this.saveDataLayerEvent({
            event: "generate_lead",
            NombresApellidos:
                this.userInfo.firstName + " " + this.userInfo.lastName,
            Celular: this.userInfo.phone,
            Email: this.userInfo.email,
            TipoDocumento: this.userInfo.documentType,
            FechaNacimiento: this.userInfo.inputDob,
          });

          this.saveDataLayerEvent({
            event: "lead",
            dimension18: this.userInfo.firstName + " " + this.userInfo.lastName,
            dimension19: this.userInfo.phone,
            dimension20: this.userInfo.email,
            dimension2: this.userInfo.inputDob,
          });

          this.loadOptions();
        }
        this.SaveTermsConditions();

        this.flags.searching = false;
      } catch (error) {
        let event = {
          channel: "web",
          trackingId: this.uuid,
          screen: "datos_cliente",
          document: this.userInfo.identificationNumber,
          name: this.userInfo.firstName,
          email: this.userInfo.email,
          phone: this.userInfo.phone,
          dob: this.userInfo.dateOfBirth,
          age: this.getAge(this.userInfo.dateOfBirth),
          data: "",
          errorType: "BACKEND",
          errorData: error.response.data,
          date: new Date(),
          ua: navigator ? navigator.userAgent : "",
        };
        trackingService.trackEvent(event);
      }
    },
    async SaveBraze() {
      let user = JSON.parse(window.localStorage.getItem("__quoteUser__"));

      let gender = this.userInfo.gender == "M" ? "MASCULINO" : "FEMENINO"

      const requestBody = {
        api_id: environment.apiGatewayBraze,
        body: {
          externalId: this.hashId,
          productId: 4,
          documentNumber: this.userInfo.identificationNumber,
          name: user.firstName,
          paternalSurname: user.lastName,
          maternalSurname: user.secondLastName,
          email: this.userInfo.email,
          gender: gender,
          phoneNumber: this.userInfo.phone,
          birthdate: this.userInfo.inputDobBraze
        },
      };

      try {
        gatewayService.postApiGateway(requestBody)
      } catch (error: any) {
        console.log(error);
      }
    },
    async SaveTermsConditions() {
      let user = JSON.parse(window.localStorage.getItem("__quoteUser__"));
      let gender = this.userInfo.gender == "M" ? "MASCULINO" : "FEMENINO"
      let model = {
        id_configuracion: 3,
        cod_tipo_identificacion: "D",
        gls_num_identificacion: this.userInfo.identificationNumber,
        gls_nombres: user.firstName,
        gls_apellido_paterno: user.lastName,
        gls_apellido_materno: user.secondLastName,
        gls_sexo: gender,
        fec_nacimiento: this.userInfo.inputDob,
        gls_mail: this.userInfo.email,
        gls_celular: this.userInfo.phone,
        aud_usr_ingreso: "rumbo-backend",
        ind_consentimiento_producto: true,
        ind_consentimiento_universal: true,
      };

      policyService.postConsentimiento(model)
    },
    openQuoteModal() {
      this.saveDataLayerEvent({
        event: "select_button",
        origen: 'Front',
        "Nombre Sección": "Rumbo",
        TipoElemento: "Botón",
        TipoAccion: "Paso 3 - Programa tus ahorros",
        CTA: "Seleccionar Botón - Intención Enviar cotización",
      });

      this.saveDataLayerEvent({
        event: "virtualEvent",
        category: "Rumbo",
        action: "Paso 3 - Programa tus ahorros",
        label: "Seleccionar Botón - Intención Enviar cotización",
      });

      // this.$refs["modal-quote"].show();
    },
    async sendQuote() {
      let _context = this;
      if (this.v$.quote.$invalid) {
        this.v$.quote.$touch();
        return;
      }

      let model = {
        email: this.quote.email,
        age: this.getAge(this.userInfo.dateOfBirth),
        gender: this.userInfo.gender === "M",
        coverage: this.goal.coverage,
        monthlyPayment: this.goal.amount,
        planId: this.selectedOption.id,
        frecuency: 1,
        document: this.userInfo.identificationNumber,
        name: this.userInfo.firstName
      };

      this.flags.sendingQuote = true;
      var result = await axios.post(`${this.isApiQuote}`, model);

      if (result.data) {
        this.flags.sendingQuote = false;
        this.flags.sendedQuote = true;

        this.saveDataLayerEvent({
          event: "select_button",
          origen: 'Front',
          "Nombre Sección": "Rumbo",
          TipoElemento: "Botón",
          TipoAccion: "Paso 3 - Programa tus ahorros",
          CTA: "Seleccionar Botón - Programa tus ahorros",
          EmailCotiza: this.quote.email,
        });

        this.saveDataLayerEvent({
          event: "virtualEvent",
          category: "Rumbo",
          action: "Paso 3 - Programa tus ahorros",
          label: "Seleccionar Botón - Programa tus ahorros",
        });

        setTimeout(() => {
          _context.$refs["modal-quote"].hide();
          _context.flags.sendedQuote = false;
          _context.quote.email = "";
          this.v$.quote.$reset();
        }, 4000);
      }
    },
    async loadOptions() {
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
      this.flags.loadingPlans = true;

      try {
        let url = `${this.isApiPlans}`;
        var result = await axios.post(
          url,
          {
            amount: this.goal.amount,
            frecuency: this.goal.period,
            age: this.getAge(this.userInfo.dateOfBirth),
            year: this.getAge(this.userInfo.dateOfBirth),
            gender: this.userInfo.gender,
            coverageAmount: this.goal.coverage,
          },
          {
            cancelToken: axiosSource.token,
          }
        );

        if (result.data) {
          this.clearOldRequest("Success");

          if (result.data.data && result.data.data.length === 0) {
            this.allOptions = [];
            this.options = [];
            this.$refs["modal-no-plans"].show();

            this.flags.loadingPlans = false;
            return;
          }

          if (result.data.data.length > 0) {
            this.flags.showSeeMore = true;
          } else {
            this.flags.showSeeMore = false;
          }

          let options = result.data.data;

          options = options.map((el, i) => {
            return {
              key: i,
              duration: el.periodicity,
              total: el.saved,
              saved: el.won,
              rentability: el.saved - el.won,
              wonPercentage: (el.amount / el.saved) * 100,
              ...el,
            };
          });

          this.allOptions = options;
          this.options = options;

          let selectedPeriodicity = 6;
          let leadData: any = JSON.parse(
            window.localStorage.getItem("__quoteLeadDetail__")
          );

          if (leadData && leadData.periodicity) {
            selectedPeriodicity = leadData.periodicity;
          }

          let defaultOption = this.options.find((el) => {
            return el.periodicity === selectedPeriodicity;
          });

          if (defaultOption) {
            this.goal.option = defaultOption.id;
            this.selectedOption = defaultOption;
          } else {
            this.goal.option = options[0].id;
            this.selectedOption = options[0];
          }

          this.flags.loadingPlans = false;
        }
      } catch (error: any) {

      }
    },
    async actualizarDataGateway() {
      let usrDataEn = {
        phone: this.userInfo.phone,
        lastName: this.userInfo.lastName,
        secondLastName: this.userInfo.secondLastName,
        name: this.userInfo.firstName,
        email: this.userInfo.email,
        gender: this.userInfo.gender,
        dob: moment(this.userInfo.dateOfBirth).format("DD/MM/YYYY"),
        fullName: this.userInfo.firstName+' '+this.userInfo.lastName+' '+this.userInfo.secondLastName
      }

      let usrData = {
        numeroTelefono: this.userInfo.phone,
        apellidoPaterno: this.userInfo.lastName,
        apellidoMaterno: this.userInfo.secondLastName,
        nombre: this.userInfo.firstName,
        email: this.userInfo.email,
        sexo: this.userInfo.gender,
        fechaNacimiento: moment(this.userInfo.dateOfBirth).format("DD/MM/YYYY"),
        nombreCompleto: this.userInfo.firstName+' '+this.userInfo.lastName+' '+this.userInfo.secondLastName
      }

      window.localStorage.setItem("__quoteUserEdit__", JSON.stringify(usrData));
      window.localStorage.setItem("__quoteUserEditEn__", JSON.stringify(usrDataEn));
      // let userEdit = JSON.parse(window.localStorage.getItem("__quoteUserEdit__"));
    },
    async nextStep() {

      this.actualizarDataGateway()
      let _context = this;

      let stepIndex = this.getStepIndex();
      let nextStep = null;
      if (stepIndex >= 0 && stepIndex < this.steps.length - 1) {
        nextStep = this.steps[stepIndex + 1];
      }

      let response = null;
      let model = null;

      if (this.currentStep.key === "userInfo") {
        /*if (!this.policies) {
          this.flags.errorPolicy = true;
          return;
        }*/

        if (this.flags.olderThanAllowedAge) {
          return;
        }
        if (this.v$.userInfo.$invalid) {
          this.v$.userInfo.$touch();
          return;
        }
        model = this.userInfo;
        this.payment.placeholder = `${this.userInfo.firstName} ${this.userInfo.lastName}`;
        this.payment.email = this.userInfo.email;
        this.payment.phone = this.userInfo.phone;
        this.payment.firstName = this.userInfo.firstName;
        this.payment.lastName = this.userInfo.lastName;
        this.payment.secondLastName = this.userInfo.secondLastName;
        this.quote.email = this.userInfo.email;

        this.loadOptions();

        this.saveDataLayerEvent({
          event: "select_button",
          origen: 'Front',
          "Nombre Sección": "Rumbo",
          TipoElemento: "Botón",
          TipoAccion: "Paso 2 - Ingresa tus datos personales",
          CTA: "Seleccionar botón - Continuar",
        });

        this.saveDataLayerEvent({
          event: "virtualEvent",
          category: "Rumbo",
          action: "Paso 2 - Ingresa tus datos personales",
          label: "Seleccionar botón - Continuar",
        });

        this.saveDataLayerEvent({
          event: "generate_lead",
          NombresApellidos:
              this.userInfo.firstName + " " + this.userInfo.lastName,
          Celular: this.userInfo.phone,
          Email: this.userInfo.email,
          TipoDocumento: this.userInfo.documentType,
          FechaNacimiento: this.userInfo.inputDob,
        });

        this.saveDataLayerEvent({
          event: "lead",
          dimension18: this.userInfo.firstName + " " + this.userInfo.lastName,
          dimension19: this.userInfo.phone,
          dimension20: this.userInfo.email,
          dimension2: this.userInfo.inputDob,
        });

        this.saveDataLayerEvent({
          event: "virtualPageView",
          pageTitle: "Rumbo | Paso 3",
          pageUrl: "/seguro-de-vida/rumbo/paso/3/",
        });

        this.initCountdown();

        let event = {
          channel: "web",
          trackingId: this.uuid,
          screen: "datos_cliente",
          document: this.userInfo.identificationNumber,
          name: this.userInfo.firstName,
          email: this.userInfo.email,
          phone: this.userInfo.phone,
          dob: this.userInfo.dateOfBirth,
          age: this.getAge(this.userInfo.dateOfBirth),
          data: {
            ...this.userInfo,
            dob: this.userInfo.dateOfBirth,
            gender: this.userInfo.gender,
            leadType: "Tibio",
          },
          errorType: "",
          errorData: "",
          date: new Date(),
          ua: navigator ? navigator.userAgent : "",
        };

        //pagina datos personales
        trackingService.trackEvent(event);
      } else if (this.currentStep.key === "goal") {
        this.generateNextPaymentDate();

        this.saveDataLayerEvent({
          event: "select_button",
          origen: 'Front',
          "Nombre Sección": "Rumbo",
          TipoElemento: "Botón",
          TipoAccion: "Paso 3 - Programa tus ahorros",
          CTA: "Seleccionar botón - Continuar",
        });

        this.saveDataLayerEvent({
          event: "virtualEvent",
          category: "Rumbo",
          action: "Paso 3 - Programa tus ahorros",
          label: "Seleccionar botón - Continuar",
        });

        this.saveDataLayerEvent({
          event: "addToCart",
          dimension9: this.selectedOption.amount,
          dimension8: this.selectedOption.duration,
          dimension10: this.periods[this.goal.period],
          dimension7: this.selectedOption.tea,
          dimension12: "Interseguro",
          ecommerce: {
            currencyCode: "PEN",
            add: {
              products: [
                {
                  id: this.selectedOption.id,
                  name: this.selectedOption.name,
                  price: this.goal.amount,
                  brand: "Interseguro",
                  category: "Rumbo",
                  variant: "Póliza",
                  quantity: 1,
                },
              ],
            },
          },
        });

        this.saveDataLayerEvent({
          event: "add_to_cart",
          origen: 'Front',
          MontoPoliza: this.selectedOption.amount,
          Periodo: this.selectedOption.duration,
          FrecuenciaPago: this.periods[this.goal.period],
          TasaInteres: this.selectedOption.tea,
          CanalVenta: "Interseguro",
          TipoDocumento: this.userInfo.documentType,
          ecommerce: {
            items: [
              {
                item_id: this.selectedOption.id,
                item_name: this.selectedOption.name,
                price: this.goal.amount,
                item_brand: "Interseguro",
                item_category: "Rumbo",
                item_variant: "Póliza",
                quantity: 1,
              },
            ],
          },
        });

        this.saveDataLayerEvent({
          event: "virtualPageView",
          pageTitle: "Rumbo | Paso 4",
          pageUrl: "/seguro-de-vida/rumbo/paso/4/",
        });

        let data = {
          ...this.selectedOption,
          paymentAmount: this.goal.amount,
          dob: this.userInfo.dateOfBirth,
          gender: this.userInfo.gender,
          leadType: "Caliente",
        };

        let event = {
          channel: "web",
          trackingId: this.uuid,
          screen: "cotiza",
          document: this.userInfo.identificationNumber,
          name: this.userInfo.firstName,
          email: this.userInfo.email,
          phone: this.userInfo.phone,
          dob: this.userInfo.dateOfBirth,
          age: this.getAge(this.userInfo.dateOfBirth),
          data: data,
          errorType: "",
          errorData: "",
          date: new Date(),
          ua: navigator ? navigator.userAgent : "",
        };

        trackingService.trackEvent(event);
      } else if (this.currentStep.key === "payment") {
        if (this.invalidExpirationDate) {
          return;
        }

        if (!this.payment.validCard) {
          this.flags.invalidCard = true;
          return;
        }

        if (this.v$.payment.$invalid) {
          this.v$.payment.$touch();
          return;
        }

        response = {
          data: {},
        };
      }

      // window.location.href = "#" + nextStep.key;
      this.currentStep = nextStep;
      this.updateStepper();

      if (response) {
        if (response.data !== undefined) {
        }
      }
    },
    getStepIndex() {
      for (let i = 0; i < this.steps.length; i++) {
        if (this.steps[i].key === this.currentStep.key) return i;
      }

      return -1;
    },
    updateStepper() {
      let stepIndex = this.getStepIndex();
      this.steps.forEach(function (el, i) {
        if (i < stepIndex) {
          el.completed = true;
          el.active = false;
        } else if (i === stepIndex) {
          el.completed = false;
          el.active = true;
        } else if (i > stepIndex) {
          el.completed = false;
          el.active = false;
        }
      });
    },
    validateCreditCard() {
      let _context = this;
      let card = valid.number(this.payment.creditCardNumber);
      let cards = {
        visa: "VISA",
        "american-express": "AMEX",
        "diners-club": "DINERS",
        mastercard: "MASTERCARD",
      };
      this.payment.validCard = card.isValid;

      if (this.payment.validCard) this.flags.invalidCard = false;

      if (card.card) {
        this.payment.creditCardType = cards[card.card.type];
      } else {
        this.payment.creditCardType = "";
      }
    },
    validateExpirationDate(event: any) {
      if (event.keyCode === 8) return;

      let expDate = this.payment.expirationDate;

      if (expDate.length === 2) {
        this.payment.expirationDate = expDate + "/";
      }
    },
    setExpirationDate() {
      if (this.payment.expirationDate.length !== 5) {
        return;
      }

      let currYear = new Date().getFullYear();
      let currMonth = new Date().getMonth() + 1;

      let expDate = this.payment.expirationDate.split("/");
      let month: any = parseInt(expDate[0]);
      let year = parseInt(expDate[1]) + 2000;

      if (month == 0 || month > 12) {
        this.flags.invalidExpirationDate = true;
        return;
      }

      if (new Date(year, month) < new Date(currYear, currMonth)) {
        this.flags.invalidExpirationDate = true;
        return;
      } else {
        this.flags.invalidExpirationDate = false;
      }

      if (month < 10) month = "0" + month;
      else month = month.toString();

      this.payment.month = month;
      this.payment.year = year;
    },
    validateInput(event: any, regex: any) {
      let key = event.key;
      let allowedKeys = [8, 9, 13];

      if (!regex.test(key) && allowedKeys.indexOf(event.keyCode) < 0)
        event.preventDefault();
    },
    maskCvv() {
      let _context = this;

      this.payment.cvv = this.payment.maskedCvv;

      setTimeout(function () {
        _context.payment.maskedCvv = _context.payment.maskedCvv.replace(
          /./g,
          "*"
        );
      }, 3000);
    },
    setOption(option) {
      this.goal.option = option.id;
      this.nextStep();
    },
    getAge(fechaNacimiento) {
      const hoy = new Date();
      const cumpleanos = new Date(fechaNacimiento);

      let edad = hoy.getFullYear() - cumpleanos.getFullYear();

      // Verifica si ya ha pasado el cumpleaños de este año
      if (hoy.getMonth() < cumpleanos.getMonth() ||
        (hoy.getMonth() === cumpleanos.getMonth() && hoy.getDate() < cumpleanos.getDate())) {
        cumpleanos.setFullYear(hoy.getFullYear() - 1);
        edad--;
      } else {
        cumpleanos.setFullYear(hoy.getFullYear());
      }

      // Calcular 6 meses después del cumpleaños
      const seisMesesDespues = new Date(cumpleanos);
      seisMesesDespues.setMonth(seisMesesDespues.getMonth() + 6);

      // Obtener siguiente cumpleaños
      const siguienteCumpleanos = new Date(cumpleanos);
      siguienteCumpleanos.setFullYear(siguienteCumpleanos.getFullYear() + 1);

      if (seisMesesDespues <= hoy && hoy <= siguienteCumpleanos) {
        edad++;
      }
      return edad;
    },
    async placeOrder() {

      // this.$refs["modal-loading"].show();
      // return;
      window.localStorage.removeItem("__culquiToken__");
      let _context = this;

      this.payment.placeholder = `${this.userInfo.firstName} ${this.userInfo.lastName}`;
      let validator: any = this.v$;
      if (validator.payment.$invalid) {
        validator.payment.$touch();
        return;
      }
      this.userInfo.email = this.payment.email;
      this.userInfo.phone = this.payment.phone;
      this.userInfo.firstName = this.payment.firstName;
      this.userInfo.lastName = this.payment.lastName;
      this.userInfo.secondLastName = this.payment.secondLastName;

      this.$refs["modal-loading"].show();
      this.flags.paying = true;

      this.saveDataLayerEvent({
        event: "checkout",
        dimension9: this.selectedOption.amount,
        dimension8: this.selectedOption.duration,
        dimension10: this.periods[this.goal.period],
        dimension7: this.selectedOption.tea,
        dimension12: "Interseguro",
        dimension18: this.userInfo.firstName + " " + this.userInfo.lastName,
        dimension19: this.userInfo.phone,
        dimension20: this.userInfo.email,
        dimension2: this.userInfo.inputDob,
        ecommerce: {
          actionField: { step: "1" },
          checkout: {
            products: [
              {
                id: this.selectedOption.id,
                name: this.selectedOption.name,
                price: this.goal.amount,
                brand: "Interseguro",
                category: "Rumbo",
                variant: "Póliza",
                quantity: 1,
              },
            ],
          },
        },
      });

      this.saveDataLayerEvent({
        event: "begin_checkout",
        origen: 'Front',
        MontoPoliza: this.selectedOption.amount,
        Periodo: this.selectedOption.duration,
        FrecuenciaPago: this.periods[this.goal.period],
        TasaInteres: this.selectedOption.tea,
        CanalVenta: "Interseguro",
        NombresApellidos:
          this.userInfo.firstName + " " + this.userInfo.lastName,
        Celular: this.userInfo.phone,
        Email: this.userInfo.email,
        FechaNacimiento: this.userInfo.inputDob,
        TipoDocumento: this.userInfo.documentType,
        ecommerce: {
          items: [
            {
              item_id: this.selectedOption.id,
              item_name: this.selectedOption.name,
              price: this.goal.amount,
              item_brand: "Interseguro",
              item_category: "Rumbo",
              item_variant: "Póliza",
              quantity: 1,
            },
          ],
        },
      });

      let objCulqi = {
        "document_number": this.userInfo.identificationNumber,
        "email": this.userInfo.email,
        "card_number": this.payment.creditCardNumber.replace(/\s+/g, ''),
        "cvv": this.payment.cvv,
        "expiration_year": this.payment.year,
        "expiration_month": this.payment.month
      }
      var result = policyService.postCulqiToken(objCulqi)
      if ((await result).data){
        this.tokenCulqi = (await result).data.data.id
      }
      // window["Culqi"].createToken();
      //

      var checkToken = setInterval(async () => {
        //debugger;
        // let token = JSON.parse(window.localStorage.getItem("__culquiToken__"));
        let token = this.tokenCulqi
        if (token) {
          clearInterval(checkToken);

          let model = {
            channel: "WEB",
            sub_channel: "WEB",
            channelSellIs: "WEB",
            porcentajeDevolucion: _context.selectedOption.wonPercentage,
            sumaAsegurada: _context.goal.coverage,
            periodoVigencia: _context.selectedOption.periodicity,
            periodoPago: _context.selectedOption.periodicity,
            frecuenciaPago: "M",
            codMoneda: "1",
            tablaDevolucion: "",
            edadContratacion: this.getAge(_context.userInfo.dateOfBirth),
            primaAsegurada: _context.goal.amount,
            primaRecurrente: _context.goal.amount,
            primaClienteAnualTotal: _context.selectedOption.saved,
            cumuloMoneda: 2,
            cumuloMonto: 0,
            montoDevolucion: _context.selectedOption.amount,
            tasaRecurrente: _context.selectedOption.amount.tea,
            config: {
              generarCotizacion: true,
            },
            asegurado: {
              hashId: this.hashId,
              nombre: _context.userInfo.firstName,
              email: _context.userInfo.email,
              apellidoPaterno: _context.userInfo.lastName,
              apellidoMaterno: _context.userInfo.secondLastName,
              fechaNacimiento: moment(_context.userInfo.dateOfBirth).format(
                "DD/MM/YYYY"
              ),
              sexo: _context.userInfo.gender,
              numeroDocumento: _context.userInfo.identificationNumber,
              numeroTelefono: _context.payment.phone,
              genero: _context.userInfo.gender === "M",
            },
            informacionPago: {
              provider: "CULQI",
              token: this.tokenCulqi,
              placeholder: `${_context.userInfo.firstName} ${_context.userInfo.lastName}`,
              card: this.payment.creditCardNumber.replace(/\s+/g, ''),
              frequency: this.goal.period,
              debitAutomatic: _context.automaticDebit,
              amount: _context.goal.amount,
              currency: "PEN",
              billingEmail: _context.payment.email,
            },

          };

          if (this.tokenCulqi) {
            try {
              var result = policyService.postEmission(model)
              try {
                if ((await result).data.data.title != "Error") {
                  _context.steps[2].completed = true;
                  _context.flags.paymentCompleted = true;
                  _context.policyNumber = (await result).data.data.message;

                  this.saveDataLayerEvent({
                    event: "virtualPageView",
                    pageTitle: "Rumbo | Paso 5",
                    pageUrl: "/seguro-de-vida/rumbo/paso/5/",
                  });

                  this.saveDataLayerEvent({
                    event: "select_button",
                    origen: 'Front',
                    "Nombre Sección": "Rumbo",
                    TipoElemento: "Botón",
                    TipoAccion: "Paso 4 - Finaliza tu compra",
                    CTA: "Seleccionar botón - Continuar",
                    Estado: "Exitoso",
                  });

                  this.saveDataLayerEvent({
                    event: "virtualEvent",
                    category: "Rumbo",
                    action: "Paso 4 - Finaliza tu compra",
                    label: "Seleccionar botón - Continuar",
                  });

                  let data = {
                    ...model,
                    paymentAmount: this.goal.amount,
                    dob: this.userInfo.dateOfBirth,
                    gender: this.userInfo.gender,
                    leadType: "Caliente",
                  };

                  let event = {
                    channel: "web",
                    trackingId: this.uuid,
                    screen: "completado",
                    document: this.userInfo.identificationNumber,
                    name: this.userInfo.firstName,
                    email: this.userInfo.email,
                    phone: this.userInfo.phone,
                    dob: this.userInfo.dateOfBirth,
                    age: this.getAge(this.userInfo.dateOfBirth),
                    data: data,
                    errorType: "",
                    errorData: "",
                    date: new Date(),
                    ua: navigator ? navigator.userAgent : "",
                  };

                  this.saveDataLayerEvent({
                    event: "purchase",
                    MontoPoliza: this.selectedOption.amount,
                    Periodo: this.selectedOption.duration,
                    FrecuenciaPago: "Mensual",
                    TasaInteres: this.selectedOption.tea,
                    CanalVenta: "Interseguro",
                    NombresApellidos:
                        this.userInfo.firstName + " " + this.userInfo.lastName,
                    Celular: this.userInfo.phone,
                    Email: this.userInfo.email,
                    FechaNacimiento: this.userInfo.inputDob,
                    TipoDocumento: this.userInfo.documentType,
                    ecommerce: {
                      transaction_id: (await result).data.id,
                      value: this.goal.amount,
                      currency: "PEN",
                      items: [
                        {
                          item_id: this.selectedOption.id,
                          item_name: this.selectedOption.duration + " años " + this.goal.amount + " soles",
                          price: this.goal.amount,
                          item_brand: "Interseguro",
                          item_category: "Rumbo",
                          item_variant: "Póliza",
                          quantity: 1,
                        },
                      ],
                    },
                  });

                  trackingService.trackEvent(event);
                }

              } catch (error) {
                this.modalErrorClient = error.response.data.data.message
                this.$refs["modal-error-client"].show();
              }

            } catch (error) {
              this.errors.payment = this.cropMessage(error.response.data.message);
              this.$refs["modal-error"].show();

              this.saveDataLayerEvent({
                event: "error",
                "Nombre Sección": "Rumbo",
                TipoElemento: "Botón",
                TipoAccion: "Errores en formulario - Paso 4 - Finaliza tu compra",
                CTA: "Seleccionar botón - Continuar",
              });

              let data = {
                ...model,
                paymentAmount: this.goal.amount,
                dob: this.userInfo.dateOfBirth,
                gender: this.userInfo.gender,
                leadType: "Caliente",
                informacionPago: {
                  provider: "CULQI",
                  token: token.id,
                  placeholder: `${_context.userInfo.firstName} ${_context.userInfo.lastName}`,
                  card: this.payment.creditCardNumber.replace(/\s+/g, ''),
                  frequency: this.goal.period,
                  debitAutomatic: _context.automaticDebit,
                  amount: _context.goal.amount,
                  currency: "PEN",
                  billingEmail: _context.payment.email,
                },
              };

              let event = {
                channel: "web",
                trackingId: this.uuid,
                screen: "pago",
                document: this.userInfo.identificationNumber,
                name: this.userInfo.firstName,
                email: this.userInfo.email,
                phone: this.userInfo.phone,
                dob: this.userInfo.dateOfBirth,
                age: this.getAge(this.userInfo.dateOfBirth),
                data: data,
                errorType: "BACKEND",
                errorData: error.response.data.message,
                date: new Date(),
                ua: navigator ? navigator.userAgent : "",
              };
              trackingService.trackEvent(event);
            }

            this.$refs["modal-loading"].hide();
            this.flags.paying = false;
          }
          else {
            this.errors.payment = token.user_message;
            this.flags.paying = false;
            let data = {
              ...model,
              paymentAmount: this.goal.amount,
              dob: this.userInfo.dateOfBirth,
              gender: this.userInfo.gender,
              leadType: "Caliente",
              informacionPago: {
                provider: "CULQI",
                token: token.id,
                placeholder: `${_context.userInfo.firstName} ${_context.userInfo.lastName}`,
                card: this.payment.creditCardNumber.replace(/\s+/g, ''),
                frequency: this.goal.period,
                debitAutomatic: _context.automaticDebit,
                amount: _context.goal.amount,
                currency: "PEN",
                billingEmail: _context.payment.email,
              },
            };
            let event = {
              channel: "web",
              trackingId: this.uuid,
              screen: "pago",
              document: this.userInfo.identificationNumber,
              name: this.userInfo.firstName,
              email: this.userInfo.email,
              phone: this.userInfo.phone,
              dob: this.userInfo.dateOfBirth,
              age: this.getAge(this.userInfo.dateOfBirth),
              data: data,
              errorType: "BACKEND",
              errorData: token.user_message,
              date: new Date(),
              ua: navigator ? navigator.userAgent : "",
            };

            trackingService.trackEvent(event);

            setTimeout(() => {
              _context.$refs["modal-loading"].hide();
              _context.$refs["modal-error"].show();

              this.saveDataLayerEvent({
                event: "virtualEvent",
                category: "Rumbo",
                action: "Paso 4 - Finaliza tu compra",
                label: "Seleccionar botón - Continuar",
              });

              this.saveDataLayerEvent({
                event: "select_button",
                origen: 'Front',
                "Nombre Sección": "Rumbo",
                TipoElemento: "Botón",
                TipoAccion: "Paso 4 - Finaliza tu compra",
                CTA: "Seleccionar botón - Continuar",
                Estado: "Error",
              });

            }, 500);
          }
        }
      }, 500);
    },
    cropMessage(mensaje) {
      // Dividimos el mensaje en oraciones usando el punto como separador
      const oraciones = mensaje.split('.');
      // Tomamos un máximo de 2 oraciones y las unimos nuevamente con puntos
      const mensajeRecortado = oraciones.slice(0, 2).join('.') + (oraciones.length > 2 ? '.' : '');
      return mensajeRecortado;
    },
    editFields() {
      this.flags.disabledInputs = !this.flags.disabledInputs;
    },
    validateAllowedAge() {
      var diff = this.getAge(this.userInfo.dateOfBirth)

      if (diff > 50) {
        this.flags.olderThanAllowedAge = true;
      } else {
        this.flags.olderThanAllowedAge = false;
      }
    },
    async changeAmount(value) {
      this.goal.amount = value;
      if (this.request) this.cancel();

      await this.loadOptions();

      this.saveDataLayerEvent({
        event: 'select_button',
        origen: 'Front',
        NombreSeccion: 'Rumbo',
        TipoElemento: 'Botón',
        TipoAccion: 'Paso 3 - Programa tus ahorros',
        CTA: 'Seleccionar botón - ' + value + " soles",
        MontoMensual: value,
        Periodo: 6,
        AporteTotal: this.selectedOption.saved,
        Ganancia: this.selectedOption.won,
        DevolucionTotal: this.selectedOption.amount,
        TREA: this.selectedOption.tea
      });

      let data = {
        ...this.selectedOption,
        paymentAmount: this.goal.amount,
        dob: this.userInfo.dateOfBirth,
        gender: this.userInfo.gender,
        leadType: "Tibio",
      };

      let event = {
        channel: "web",
        trackingId: this.uuid,
        screen: "cotiza",
        document: this.userInfo.identificationNumber,
        name: this.userInfo.firstName,
        email: this.userInfo.email,
        phone: this.userInfo.phone,
        dob: this.userInfo.dateOfBirth,
        age: this.getAge(this.userInfo.dateOfBirth),
        data: data,
        errorType: "",
        errorData: "",
        date: new Date(),
        ua: navigator ? navigator.userAgent : "",
      };

      trackingService.trackEvent(event);
    },
    cancel() {
      this.request.cancel();
      this.clearOldRequest("Cancelled");
    },
    clearOldRequest(msg) {
      this.request.msg = msg;
      this.requests.push(this.request);
      this.request = null;
    },
    goHome() {
      this.$router.push("/");
    },
    async sendOtp() {
      if (this.v$.login.$invalid) {
        this.v$.login.$touch();
        return;
      }

      this.saveDataLayerEvent({
        event: "login",
        userid: this.login.identificationNumber,
      });

      this.flags.logingIn = true;

      let model = {
        identificationType: this.login.identificationType,
        identificationNumber: this.login.identificationNumber,
      };

      var result = await axios.post(
        `${this.apiUrl}sign-in/otp/generate`,
        model
      );

      if (result.data) {
        this.flags.validateOtp = true;
        this.flags.logingIn = false;

        this.otp = result.data;
      }
    },
    async validateOtp(e: any) {
      e.preventDefault();

      let validator: any = this.v$;

      if (validator.otpCode.$invalid) {
        validator.otpCode.$touch();
        return;
      }

      this.flags.logingIn = true;

      this.login.identificationNumber = this.login.identificationNumber;

      let model = {
        identificationType: this.login.identificationType,
        identificationNumber: this.login.identificationNumber,
        code: this.otpCode.code,
        otpId: this.otp.otpId,
      };

      try {
        var result = await axios.post(
          `${this.apiUrl}sign-in/otp/validate`,
          model
        );

        if (result.data) {
          window.localStorage.setItem("__auth__", JSON.stringify(result.data));

          let headers = {
            headers: {
              Authorization:
                result.data.token_type + " " + result.data.access_token,
            },
          };

          var userResult = await axios.get(`${this.apiUrl}users/me`, headers);

          if (userResult.data) {
            window.localStorage.setItem(
              "__user__",
              JSON.stringify(userResult.data)
            );
          }

          //   this.sendLoginEvent();

          if (this.login.identificationNumber.toUpperCase() === "XX9999XX") {
            window.location.href = `/seguro-de-vida/rumbo/admin/policies`;
          } else {
            window.location.href = `/seguro-de-vida/rumbo/client-zone/policies`;
          }
        } else {
          this.flags.logingIn = false;
        }
      } catch (error) {
        console.log(error);
        this.flags.logingIn = false;
        this.errors.login = error.response.data.detail;
      }
    },
    togglePlans() {
      if (this.options.length !== this.allOptions.length) {
        this.options = this.allOptions;
      } else {
        this.options = this.allOptions.slice(0, 3);
      }
    },
    prevStep() {
      if (this.currentStep.key === "userInfo") {
        this.goHome();
      } else {
        let key = "";

        if (this.currentStep.key === "goal") {
          key = "userInfo";
          this.steps[1].active = true;
          this.steps[1].completed = false;
          this.steps[2].active = false;
          this.steps[2].completed = false;
        } else if (this.currentStep.key === "payment") {
          key = "goal";
          this.steps[2].active = false;
          this.steps[2].completed = false;
        }

        this.loadForm(key);
      }
    },
    loadForm(key) {
      let stepIndex = null;
      // let step = null;
      let step = this.steps.find((el, i) => {
        return el.key === key;
      });

      if (step) {
        this.currentStep = step;
      }
    },
    formatNumber(number) {
      let numberArray = number.toString().split("");
      let formattedNumberArray = [];

      numberArray.reverse().forEach((el, i) => {
        if (i % 3 === 0 && i !== 0) {
          formattedNumberArray.push(",");
        }
        formattedNumberArray.push(el);
      });

      formattedNumberArray = formattedNumberArray.reverse();
      number = formattedNumberArray.join("");

      return number;
    },
    changePeriod() {
      if (this.goal.period == "1") {
        this.goal.amount = 240;

        this.amountSlider.min = 100;
        this.amountSlider.max = 700;
        this.amountSlider.interval = 20;
      } else if (this.goal.period == "3") {
        this.goal.amount = 1008;

        this.amountSlider.min = 336;
        this.amountSlider.max = 1960;
        this.amountSlider.interval = 56;
      } else if (this.goal.period == "12") {
        this.goal.amount = 3600;

        this.amountSlider.min = 1200;
        this.amountSlider.max = 7000;
        this.amountSlider.interval = 200;
      }

      this.loadOptions();
    },
    editField(field) {
      this.flags[`disabled${field}`] = !this.flags[`disabled${field}`];
    },
    saveDataLayerEvent(event: any) {
      if (window["dataLayer"]) {
        event.userID = this.hashId;

        window["dataLayer"].push(event);
      }
    },
    savePaymentEvent() {
      if (
        !this.payment.validCard ||
        this.payment.year === "" ||
        this.payment.month === "" ||
        this.payment.cvv === ""
      )
        return;
    },
    changeOption(plan) {
      this.selectedOption = plan;

      let data = {
        ...this.selectedOption,
        paymentAmount: this.goal.amount,
        dob: this.userInfo.dateOfBirth,
        gender: this.userInfo.gender,
        leadType: "Tibio",
      };

      let event = {
        channel: "web",
        trackingId: this.uuid,
        screen: "cotiza",
        document: this.userInfo.identificationNumber,
        name: this.userInfo.firstName,
        email: this.userInfo.email,
        phone: this.userInfo.phone,
        dob: this.userInfo.dateOfBirth,
        age: this.getAge(this.userInfo.dateOfBirth),
        data: data,
        errorType: "",
        errorData: "",
        date: new Date(),
        ua: navigator ? navigator.userAgent : "",
      };

      this.saveDataLayerEvent({
        event: 'select_button',
        origen: 'Front',
        NombreSeccion: 'Rumbo',
        TipoElemento: 'Botón',
        TipoAccion: 'Paso 3 - Programa tus ahorros',
        CTA: 'Seleccionar botón - ' + plan.duration + ' años',
        MontoMensual: this.goal.amount,
        Periodo: plan.duration,
        AporteTotal: this.selectedOption.saved,
        Ganancia: this.selectedOption.won,
        DevolucionTotal: this.selectedOption.amount,
        TREA: this.selectedOption.tea
      });

      trackingService.trackEvent(event);
    },
    setDocumentLength() {
      var length = 8;
      if (this.userInfo.identificationType !== "dni") {
        length = 9;
      }

      this.documentLength = length;
    },
    onWindowScroll(event: any) { },
    onMouseMove(event: any) {
      if (this.currentStep.key !== "goal") return;

      if (this.freeMonthModal) return;

      let width = window.innerWidth;
      if (event.clientY < 100 && width - event.clientX < 100 && width > 500) {
        let _context = this;
        // _context.$refs["modal-free-month"].show();

        this.initCountdown();
        this.freeMonthModal = true;
      }
    },
    closeFreeMonthModal() {
      // this.$refs["modal-free-month"].hide();
    },
    changePlaceholder(event: any) {
      let el = event.target;
      el.setAttribute("placeholder", "dd/mm/aaaa");
    },
    revertPlaceholder(event: any) {
      let el = event.target;
      el.setAttribute("placeholder", "F. nacimiento");
    },
    validateDob(event: any) {
      let isBackspace = event.keyCode === 8;

      if (!this.userInfo.inputDob || this.userInfo.inputDob === "") {
        this.flags.invalidAge = true;
        return;
      }

      let dateParts = this.userInfo.inputDob.split("/");

      if (dateParts[0] && dateParts[0] !== "") {
        if (
          !dateParts[0] ||
          dateParts[0] > 31 ||
          dateParts[0] == 0 ||
          dateParts[0].length === 0
        ) {
          this.flags.invalidAge = true;
          return;
        }
      } else {
        this.flags.invalidAge = true;
        return;
      }

      if (dateParts[1] && dateParts[1] !== "") {
        if (
          !dateParts[1] ||
          dateParts[1] > 12 ||
          dateParts[1] == 0 ||
          dateParts[1].length === 0
        ) {
          this.flags.invalidAge = true;
          return;
        }
      } else {
        this.flags.invalidAge = true;
        if (dateParts[0].length === 2 && !isBackspace) return;
      }

      if (dateParts[2] && dateParts[2] > 1000 && dateParts[2].length === 4) {
        let date: any = new Date(
          dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2]
        );

        if (date === "Invalid Date") {
          this.flags.invalidAge = true;
          return;
        }

        if (date > this.disabledDates.from) {
          this.flags.invalidAge = true;
          return;
        }

        this.userInfo.dateOfBirth = date;

        this.flags.invalidAge = false;
        this.validateAllowedAge();
      } else {
        if (!dateParts[2] || dateParts[2] > 1000) {
          this.flags.invalidAge = true;
          return;
        }

        if (!dateParts[2] || dateParts[2] === "")
          if (dateParts[1].length === 2 && !isBackspace) {
            this.flags.invalidAge = true;
            return;
          }
      }
    },
    updateUserInfo(prop) {
      this.userInfo[prop] = this.payment[prop];
    },
    closeModal(modal) {
      this.$refs[modal].hide();
      // window.location.href = this.basePath + "/funds/all";
    },
    navigateToStep(step) {
      if (!step.completed) return;

      let index = 0;
      this.steps.forEach((el, i) => {
        if (el.key === step.key) {
          index = i;
        }
      });

      this.currentStep = step;

      this.steps.forEach((el, i) => {
        if (i <= index) {
          el.completed = true;
          el.active = true;
        } else {
          el.completed = false;
          el.active = false;
        }
      });
    },
    openWapp() {
      this.saveDataLayerEvent({
        event: "select_button",
        origen: 'Front',
        "Nombre Sección": "Rumbo",
        TipoElemento: "Botón",
        TipoAccion: "Canales de comunicación",
        CTA: "WhatsApp - Comunicarse con un asesor",
      });

      this.saveDataLayerEvent({
        event: "virtualEvent",
        category: "Rumbo",
        action: "Canales de comunicación",
        label: "WhatsApp - Comunicarse con un asesor",
      });
    },
    changeComunicationPolicyContiion() {
      // if(this.comunicationPolicies.profile && this.comunicationPolicies.offers) {
      //   this.comunicationPolicies.all = true;
      // } else {
      //   this.comunicationPolicies.all = false;
      // }

      if (this.comunicationPolicies.all) {
        this.comunicationPolicies.profile = true;
        this.comunicationPolicies.offers = true;
      } else {
        this.comunicationPolicies.profile = false;
        this.comunicationPolicies.offers = false;
      }
    },
    generateUUID() {
      // Genera un número aleatorio hexadecimal de 4 dígitos
      function generateRandomHex() {
        return Math.floor(Math.random() * 0x10000).toString(16).padStart(4, '0');
      }

      // Genera un UUID en formato "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
      return (
        generateRandomHex() + generateRandomHex() + '-' +
        generateRandomHex() + '-4' +
        generateRandomHex().substr(0, 3) + '-' +
        (8 | Math.random() * 4).toString(16).substr(2, 1) +
        generateRandomHex().substr(1, 3) + '-' +
        generateRandomHex()
      );
    },
    cleanInput(key) {
      if(this.userInfo[key].includes('*')){
        this.userInfo[key] = ''
      }
    },
  },
});
</script>
<style src="@vueform/slider/themes/default.css"></style>
<style lang="scss">
@import "./../../styles/abstracts/variables";


/**DESKTOP */
.hidden-mobile {
  @media (max-width: 479px) {
    display: none;
  }
}

/**MOBILE */
.visible-mobile {
  display: none;

  @media (max-width: 479px) {
    display: block;
  }
}

/**IMG-DESKTOP */
.img-desktop {
  @media (max-width: 479px) {
    display: none;
  }
}

/**IMG-MOBILE */
.img-mobile {
  display: none;

  @media (max-width: 479px) {
    display: block;
  }
}

/**NAVBAR-QUOTE */
.navbar-quote {
  background-color: $headerFontColor;
  border-bottom: 2px solid $primaryBlue;

  .navbar-brand {
    padding-left: 15px;
    margin-top: 3px;

    img {
      width: 140px;

      &:first-child {
        width: 160px;
        margin-right: 15px;
      }
    }
  }

  @media (max-width: 479px) {
    .navbar-brand {
      img {
        width: 100px;

        &:first-child {
          width: 120px;
        }
      }
    }
  }
}

/**PROMOTION */
.promotion {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  width: 100%;

  img {
    height: 35px;
    width: 35px;
  }

  span {
    color: #0855c4;
    font-size: 12px;
    text-align: center;
    // width: 90%;
    font-weight: 500;
  }
}

/**COUNTDOWN */
.countdown {
  background: rgb(41, 211, 239);
  background: linear-gradient(180deg,
      rgba(41, 211, 239, 1) 21%,
      rgba(37, 161, 181, 1) 100%,
      rgba(2, 0, 36, 1) 100%);
  display: flex;
  height: 60px;

  &__content {
    display: flex;
    width: 100%;
    align-items: center;
    flex-direction: row;
    margin-left: 8px;

    &__wpp {
      position: relative;
      width: 70px;
      padding-left: 10px;
      margin-right: 8px;

      @media (min-width: $mobileBreak3) {
        width: 60px !important;
      }

      @media (min-width: 350px) {
        padding-left: 5px;
        width: 50px !important;
      }

      @media (min-width: 400px) {
        margin-right: 10px;
      }

      img:first-child {
        width: 40px;
        height: 40px;
        margin-bottom: 4px;

        @media (max-width: $mobileBreak3) {
          width: 40px;
          height: 40px;
        }
      }

      img:last-child {
        position: absolute;
        // width: 17px;
        width: 44px;
        right: 0px;
        // bottom: 5px;
        bottom: -26px;
        height: 44px;

        @media (min-width: 350px) {
          right: 0px;
        }
      }
    }

    &__gift {
      @media (min-width: 300px) {
        margin-right: 5px;
        margin-left: 9px;
      }

      @media (min-width: 375px) {
        margin-right: 5px;
        margin-left: 5px;
      }

      @media (width: 360px) {
        margin-right: 0px;
        margin-left: -5px;
      }

      &__text {
        &__title {
          span {
            display: block;
            width: 100%;
            color: white;
            font-size: 14px;
            align-items: center;
            font-weight: 400;

            img {
              margin-left: 5px;
              margin-right: 5px;
            }

            @media (max-width: 375px) {
              font-size: 12px;
            }
          }
        }

        &__subtitle {
          display: flex;
          align-items: center;

          &__spanMonthFree {
            display: block;
            background-color: #ea0b90;
            border-radius: 5px;
            text-align: center;
            margin-right: 5px;
            color: #ffffff;
            font-size: 14px;
            font-weight: 500;
            padding: 0px 5px 0px 5px;
            height: 20px;

            @media (min-width: $mobileBreak3) {
              font-size: 14px !important;
              width: 100%;
              height: 22px;
            }
          }
        }
      }
    }
  }

  .countdown {
    &__counter {
      &__item1 {
        font-family: $firstFont;
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        margin-top: 5px;
        margin: 0px 15px 0px 0px;

        @media (min-width: $mobileBreak3) {
          margin: 0px 15px 0px 0px !important;
        }

        @media (min-width: 380px) {
          margin: 0px 15px 0px 6px !important;
        }

        @media (min-width: 400px) {
          margin: 0px 15px 0px 10px !important;
        }

        span {
          font-weight: lighter !important;
        }

        &__element1 {
          width: 33%;
          margin-left: 8px;

          span {
            display: block;
            color: white;
            line-height: 15px;
            text-align: center;
            font-size: 11px;

            @media (max-width: 396px) {
              font-size: 9px !important;
            }
          }
        }

        &__element2 {
          width: 33%;
          margin-left: 15px;

          span {
            display: block;
            color: white;
            line-height: 15px;
            font-size: 11px;
            text-align: center;

            @media (max-width: 396px) {
              font-size: 9px !important;
            }
          }
        }

        &__element3 {
          width: 33%;
          margin-left: 15px;

          span {
            display: block;
            color: white;
            line-height: 15px;
            font-size: 11px;
            text-align: center;

            @media (max-width: 396px) {
              font-size: 9px !important;
            }
          }
        }

        &__number {
          display: flex;
          justify-content: center;

          h6 {
            display: flex;
            justify-content: center;
            font-size: 20px;
            align-items: center;
            margin-bottom: 0px;
            width: 40px;
            color: $primaryGray;
            height: 30px;
            font-weight: 600;
            border-radius: 5px;
            text-align: center;
            padding: 5px;
            background-color: #ffffff;

            @media (max-width: 396px) {
              width: 26px !important;
              font-size: 16px !important;
            }

            @media (min-width: $mobileBreak3) {
              width: 100% !important;
              font-size: 20px !important;
            }
          }
        }
      }
    }
  }
}

/**DESCUBRE EL REGALO... */
.headerInfo {
  background: rgb(41, 211, 239);
  background: linear-gradient(180deg,
      rgba(41, 211, 239, 1) 21%,
      rgba(37, 161, 181, 1) 100%,
      rgba(2, 0, 36, 1) 100%);
  display: flex;
  height: 60px;

  .headerInfo__content {
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
    justify-content: center;
    display: flex;
    width: 100%;

    span {
      font-size: 15px;
      justify-content: center;
      font-weight: 600;
      // letter-spacing: 1.3px;
      // word-spacing: 2px;

      img {
        width: 30px;
        height: 30px;
        margin-right: 5px;
        margin-left: 6px;
      }
    }
  }
}

/**QUOTE */
.quote {
  padding-top: 75px;
  min-height: calc(100vh);
  background-color: #f4f6fc;
  overflow: hidden;

  .btn-back {
    font-size: 16px;
    color: $colorBlack !important;
    text-decoration: none;
    margin-bottom: 15px;
    font-weight: 500;
    display: block;
  }

  .row {
    @media screen and (min-width: 940px) {
      &.res {
        justify-content: center;
        margin-top: 1.5rem !important;
        margin-right: 4rem !important;
      }
    }
  }

  &__stepper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    position: relative;
    margin-bottom: 30px;
    // margin-top: -45px;

    @media (max-width: $mobileBreak) {
      padding: 0px 30px 0px 30px;
    }

    &__item {
      display: block;
      width: 45px;
      height: 45px;
      border-radius: 50%;
      border: 2px solid #d0dff4;
      background-color: #fff;
      z-index: 10;
      text-align: center;
      font-size: 25px;
      font-weight: 500;
      color: #707070;
      padding-top: 2px;
      cursor: pointer;

      img {
        display: none;
        width: 18px;
        margin: auto;
      }

      .name {
        font-weight: 400;
        font-size: 14px;
        color: #707070;
        white-space: nowrap;
        width: 130px;
        text-align: center;
        margin-left: calc((130px - 42px) / -2);
        margin-top: 10px;
      }

      &.active {
        background-color: $primaryBlue;
        color: #fff;
        border-color: $primaryBlue;

        .name {
          color: $primaryBlue;
        }
      }

      &.completed {
        background-color: $primaryBlue;
        color: #fff;
        border-color: $primaryBlue;

        .name {
          color: $primaryBlue;
        }

        img {
          display: block;
        }

        &:before {
          background-color: $primaryBlue !important;
        }
      }

      &:not(:last-child) {
        &:before {
          content: "";
          display: block;
          width: calc(100% - 53px);
          height: 3px;
          background-color: #d0dff4;
          position: absolute;
          top: 21px;
          margin-left: 44px;
        }
      }

      @media (max-width: 479px) {
        &:not(:last-child) {
          &:before {
            width: calc(100% - 113px);
          }
        }
      }
    }

    @media (max-width: 479px) {
      margin-top: 20px;
    }
  }

  &__step {
    position: relative;

    .row-padding {
      margin-right: 50px !important;

      @media screen and (max-width: $mobileBreak) {
        margin-right: 0 !important;
      }
    }

    form {
      .form-group {
        .period-selector {
          .custom-control-input:checked+.custom-control-label {
            border-color: $primaryBlue;
            background-color: red !important;
          }
        }
      }
    }

    &__back {
      position: absolute;
      left: -45px;
      display: none;
    }

    &__title {
      font-weight: 500;
      font-size: 25px;
      color: $mainColor;
      text-align: center;

      @media (max-width: 479px) {
        //padding-bottom: 15px !important;
      }
    }

    &__title {
      margin-top: 20px;
      color: $primaryBlue;
    }

    &__description {
      font-size: 20px;
      color: $mainColor;
      text-align: center;
      margin-bottom: 40px;
    }

    .card-form {
      // border-radius: 25px;

      .card-body {
        // padding: 35px;

        .row {
          margin-left: -7px;
          margin-right: -7px;

          div[class^="col"] {
            padding-left: 7px;
            padding-right: 7px;
          }
        }
      }

      @media (max-width: 479px) {
        box-shadow: none;

        .card-body {
          padding: 0;
        }
      }
    }

    .card-plan {
      border-radius: 0;
      width: 300px;

      &__quote-btn {
        margin-bottom: 11px;

        button {
          font-size: 14px;
          font-weight: 500;
          border-width: 1px;
          height: 50px;
          width: 65%;
        }
      }

      .card-body {
        padding-left: 25px;
        padding-right: 45px;
      }

      .body-card {
        padding-left: 23px;
        padding-right: 5px;
        padding-top: 4px;
        padding-bottom: 12px;
      }

      .card-footer {
        border: none;
        background: #e2f7ff 0% 0% no-repeat padding-box;
        font-size: 13px;
        color: $primaryBlue;
        font-weight: 500;
        text-align: right;
        // padding: 10px 14px 15px 80px;

        @media (max-width: 479px) {
          height: 68px;
          font-size: 28px;
          font-weight: 600;
          display: flex;
          justify-content: space-between;
          align-items: center;
          line-height: 20px;
          text-align: center;
        }

        &__interest {
          font-size: 32px !important;
          text-align: right;
          font-weight: bold;
        }

        span {
          font-size: 14px;
          font-weight: lighter;
          font-weight: 600;
          text-align: left;
          // padding-right: 25px;
        }

        &__txt {
          font-size: 13px !important;
          font-weight: 600 !important;
          line-height: 12px;
        }

        &__text {
          font-size: 14px;
          font-weight: 600;
          line-height: 15px;
        }
      }

      .Pinkbtn {
        button {
          height: 40px;
          width: 65%;
          font-size: 16px;
        }
      }

      .Pinkbtn {
        display: flex;
        justify-content: center;

        button {
          height: 50px;
          background-color: $pink;
          color: $headerFontColor;
          cursor: pointer;
          font-size: 16px;
          font-weight: 500;
        }
      }

      &__item {
        display: flex;
        font-size: 14px;
        align-items: center;
        margin: 7px 0px 7px 0px;
        justify-content: space-between;

        span {
          font-size: 17px;
          font-weight: lighter;
          width: 125px;
          text-align: right;
        }

        b {
          display: flex;
          font-weight: bold;
          font-size: 18px;
          color: $mainColor;
          width: 90px;

          span {
            display: block;
            font-weight: bold;
            width: 35px;
            text-align: center;
          }
        }
      }

      &__item {
        margin: 0px;

        span {
          font-size: 14px;
          text-align: left;
          font-weight: 500;
          color: #0855c4;
        }

        b {
          justify-content: right;
          font-weight: 500;
          color: $sixtColor;
        }
      }

      .info {
        .card-body {
          h4 {
            font-size: 14px;
            font-weight: 500;
            color: $mainColor;
          }
        }

        &__item {
          display: flex;
          font-size: 12px;
          align-items: center;

          &:not(:last-child) {
            margin-bottom: 10px;
          }

          img {
            width: 35px;
            height: 45px;
            margin-right: 10px;
          }

          .d-block {
            text-align: center;
            font-weight: 500;
            color: $mainColor;
          }
        }
      }

      // @media (max-width: 479px) {
      //     margin-top: 40px;
      //     background: #e2f7ff 0% 0% no-repeat padding-box;
      //     border-radius: 10px !important;

      //     .card-body {
      //         display: flex;
      //         padding: 0px 15px 15px 15px !important;
      //         justify-content: center;
      //     }

      //     .card-footer {
      //         padding: 0px 40px 10px 40px;
      //         display: flex;
      //         align-items: center;
      //         flex-wrap: wrap;

      //         .interest {
      //             margin-top: 5px;
      //             align-items: center;
      //             width: 115px;
      //             text-align: right;
      //             font-size: 32px;
      //             font-weight: 700;
      //             line-height: 22px;

      //             span {
      //                 font-size: 8px;
      //                 width: 100%;
      //                 font-weight: 400;
      //             }
      //         }

      //         span:not(.d-block) {
      //             font-weight: 400 !important;
      //             font-size: 15px;
      //             text-align: right;
      //             width: calc(100% - 115px);
      //             font-weight: 500 !important;
      //         }

      //         span {
      //             &.d-block {
      //                 color: #707070;
      //                 font-size: 12px;
      //             }
      //         }
      //     }

      //     &__item {
      //         flex-direction: column;
      //         margin-bottom: 0 !important;
      //         align-items: center;
      //         justify-content: center;
      //         align-items: center;
      //         position: relative;

      //         &:nth-child(2) {
      //             padding-left: 12px;
      //             padding-right: 12px;

      //             &:before,
      //             &:after {
      //                 content: "+";
      //                 color: $mainColor;
      //                 position: absolute;
      //                 top: 10px;
      //                 font-size: 22px;
      //                 font-weight: 500;
      //             }

      //             &:before {
      //                 content: "+";
      //                 left: 1px;
      //             }

      //             &:after {
      //                 content: "=";
      //                 right: 3px;
      //             }
      //         }

      //         span {
      //             display: block;
      //             order: 2;
      //             font-size: 12px;
      //             line-height: 10px;
      //             color: #707070;
      //             text-align: center;
      //             width: auto;
      //             font-weight: 400;
      //         }

      //         b {
      //             display: flex;
      //             justify-content: center;
      //             font-weight: 500 !important;
      //             order: 1;
      //             font-size: 18px;
      //             color: $mainColor;
      //         }
      //     }
      // }

      @media (max-width: 319px) {
        .card-footer {
          padding-top: 0;
          display: flex;
          align-items: center;

          .interest {
            margin-top: 0;
            align-items: center;
            margin-left: 15px;
          }
        }

        &__item {
          flex-direction: column;
          margin-bottom: 0 !important;
          align-items: center;
          justify-content: center;
          align-items: center;
          position: relative;

          &:nth-child(2) {
            padding-left: 15px;
            padding-right: 15px;

            &:before,
            &:after {
              content: "+";
              color: $mainColor;
              position: absolute;
              top: 0px;
              font-size: 16px;
              font-weight: 500;
            }

            &:before {
              content: "+";
              left: 5px;
            }

            &:after {
              content: "=";
              right: 5px;
            }
          }

          span {
            order: 2;
            font-size: 12px;
            color: #707070;
            text-align: center;
            width: auto;
          }

          b {
            order: 1;
            font-size: 13px;
            color: $mainColor;
          }
        }
      }
    }

    .card-plan {
      border-radius: 0.5px !important;

      .simulator {
        padding: 5px 10px 5px 10px;
        border-radius: 0;
        font-weight: 500;
        background-color: $primaryBlue;
        color: $headerFontColor;
      }

      .card-body {
        padding: 0 20px 0 20px;
      }
    }

    .card-info {
      .card-body {
        h4 {
          font-size: 14px;
          font-weight: 500;
          color: $mainColor;
        }
      }

      &__item {
        display: flex;
        font-size: 12px;
        align-items: center;

        &:not(:last-child) {
          margin-bottom: 10px;
        }

        img {
          width: 35px;
          height: 45px;
          margin-right: 10px;
        }

        span {
          text-align: center;
          font-weight: 500;
          color: $mainColor;
        }
      }

      @media (max-width: 479px) {
        border: none;
      }
    }

    form {
      .form-section-title {
        font-size: 18px;
        color: $secondColor;
      }

      .policies {
        font-size: 12px;
        word-spacing: 0.5px;
        color: $primaryGray;
        text-align: center;
        margin-bottom: 5px;

        .custom-control {
          display: flex;
          justify-content: center;

          input {
            position: absolute;
          }

          &-label {
            position: relative;
            display: flex;
            justify-content: center;
            padding-left: 25px;

            &:before {
              border-radius: 50%;
              border-color: #01adee;
              border-width: 2px;
              left: 0 !important;
              top: 0 !important;
            }

            &:after {
              left: 0 !important;
              top: 0 !important;
            }
          }
        }

        a {
          color: $primaryBlue;
          font-weight: 500;
          text-decoration: underline;
        }
      }

      .payment-footer {
        font-size: 12px;
        text-align: center;
        color: $sixtColor;
        padding-bottom: 20px;

        .policies {
          font-size: 12px;

          a {
            color: inherit;
          }
        }

        .backup {
          margin-bottom: 30px;
          display: flex;
          justify-content: center;

          img {
            width: 38px;
            height: 27px;
            margin-right: 10px;
            margin-top: 8px;
          }

          b {
            color: #6e6b7b;
            font-size: 15px;
            font-weight: 500 !important;
          }

          span {
            color: #6e6b7b;
            font-size: 12px;
          }
        }
      }

      .form-group {
        position: relative;
        margin-bottom: 20px;

        &.invalid,
        .invalid {
          .form-control {
            border-color: #ea5455 !important;
          }

          small {
            display: block;
          }
        }

        small {
          display: none;
          margin-top: 5px;
          padding-left: 10px;
          color: #ea5455;
          font-weight: 500;
          font-size: 12px;
        }

        .custom-radio {
          label {
            font-size: 16px;
          }
        }

        .custom-checkbox {
          label {
            font-size: 14px;

            &:before {
              border-radius: 50%;
            }

            a {
              color: $mainColor;
              text-decoration: underline;
            }
          }
        }

        &>label {
          font-size: 14px;
          color: $primaryBlue;

          &+.form-control {
            &+label {
              top: 30px;
            }
          }
        }

        .form-control {
          border: 1px solid #c5c5c5;
          border-radius: 4px;
          border-width: 2px;
          height: 57px;
          font-size: 14px;

          @media screen and (max-width: 940px) {
            height: 57px;
          }

          @media screen and (max-width: 479px) {
            height: 45px;
          }

          &+label {
            font-size: 14px;
            position: absolute;
            top: 3px;
            left: 15px;
            font-weight: bold;
            display: none;
          }
        }

        .vdp-datepicker {
          input[readonly] {
            background-color: #fff;
          }

          input[disabled] {
            background-color: #efefef !important;
          }

          &+label {
            font-size: 14px;
            position: absolute;
            top: 5px;
            left: 15px;
            font-weight: bold;
          }
        }

        select {
          -webkit-appearance: none;
          -moz-appearance: none;
          text-indent: 1px;
          -webkit-appearance: none;
          -moz-appearance: none;
          background-image: url("../../assets/images/app/angle-down.svg");
          background-repeat: no-repeat;
          background-position-x: calc(100% - 19px);
          background-position-y: 19px;
        }

        .cc-input {
          padding-left: 65px !important;
        }

        .input-icon {
          position: absolute;
          bottom: 12px;
          left: 20px;
        }

        .valid-card-icon {
          position: absolute;
          left: 87%;
          top: 22px;

          @media screen and (max-width: 479px) {
            top: 15px !important;
          }
        }

        .input-icon-left {
          position: absolute;
          top: 20px;
          left: 22px;

          @media screen and (max-width: 479px) {
            top: 15px;
          }

          &+.form-control {
            padding-left: 45px;
          }
        }

        .input-card {
          bottom: 22px;
          position: absolute;
          top: 17px;
          margin-left: 2px;

          @media screen and (max-width: 479px) {
            top: 11px !important;
          }
        }

        .btn-edit {
          font-size: 14px;
          color: #707070;
          display: flex;
          align-items: center;
          position: absolute;
          top: 25px;
          right: 9px;

          img {
            width: 20px;
          }
        }

        .btn-send {
          background-color: $pink;
          border-radius: 3px;
          height: 52px;
          font-size: 16px;
          color: #fff;
          width: 240px;
          display: block;
          margin: auto;
          box-shadow: 0px 3px 10px #00000029;
          margin-bottom: 20px;
        }

        .btn-default {
          background-color: #e7e7eb;
          border-radius: 3px;
          height: 52px;
          font-size: 18px;
          color: #707070;
          width: 240px;
        }

        &.toggle-check {
          padding-left: 0;

          input {
            display: none;
            display: none;

            &:checked {
              &+label {
                &:before {
                  background: #141553;
                }

                &:after {
                  left: 16px;
                }
              }
            }
          }

          label {
            padding-left: 40px;
            display: block;
            position: relative;
            font-size: 14px;
            cursor: pointer;

            &:before {
              content: "";
              display: block;
              width: 35px;
              height: 20px;
              background: rgba(#707070, 0.5);
              border-radius: 100px;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 0;
              transition: 200ms;
            }

            &:after {
              content: "";
              display: block;
              width: 18px;
              height: 18px;
              background: #fff;
              border-radius: 100px;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 1px;
              transition: 200ms;
            }
          }
        }

        .amount-selector {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          max-width: 500px;
          margin-top: 40px;
          margin-left: 8px;
          margin-right: 8px;

          span {
            font-size: 18px;
            margin-top: 10px;
            color: #7b7c9a;
            position: relative;
          }

          .vue3-slider {
            .tooltip {
              font-size: 18px;
              font-weight: 500;
            }

            .track {
              height: 10px;
              border-radius: 10px;
            }

            .track-filled {
              height: 10px;
              border-radius: 10px;
            }

            .handle {
              top: 0px;
              width: 10px;
              height: 10px;
              border-radius: 100%;
              background-color: $primaryBlue !important;

              &::before {
                content: "";
                position: absolute;
                top: 3px;
                left: 3px;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background-color: white;
              }

              &.hover {
                background-color: #36abff;
              }
            }
          }

          .slider-target {
            width: 100%;
            height: 10px;

            &:hover .slider-connects .slider-connect {
              background-color: #36abff;
            }

            .slider-connects {
              .slider-connect {
                background-color: $primaryBlue !important;
              }
            }

            .slider-origin {
              .slider-tooltip {
                font-family: $firstFont;
                font-weight: 500;
                font-size: 18px;
                color: $primaryBlue;
                border: none;
                bottom: 28px;
                background-color: transparent;

                &::before {
                  content: none;
                }
              }

              .slider-handle {
                width: 26px;
                height: 26px;
                box-shadow: none;
                background-color: $primaryBlue !important;
                transition: 0.3s;

                &:hover {
                  background-color: #36abff;
                }
              }

              .slider-touch-area {
                &::before {
                  content: "";
                  position: absolute;
                  top: 8px;
                  left: 8px;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  background-color: white;
                }
              }
            }
          }

          input {
            width: 100%;
          }
        }

        .period-selector {
          display: flex;
          width: 100%;
          height: 50px;

          .custom-control {
            padding: 0;
            margin: 0;
            width: 100%;

            &-input {
              display: none;

              &:checked {
                &+.custom-control-label {
                  border-color: $mainColor;
                  background: $mainColor;
                  color: #fff;
                }
              }
            }

            &-label {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 0;
              width: 100%;
              height: 40px;
              padding: 0;
              text-align: center;
              background: #fff;
              cursor: pointer;
              border: 1px solid #7b7c9a;
              font-size: 18px;
              font-weight: 500;
              border-right: none;
              color: #5e5873;
              font-weight: 500;

              &:before,
              &:after {
                content: none;
              }
            }

            &:first-child {
              .custom-control-label {
                border-radius: 100px 0 0 100px;
                // border: 1px solid #7b7c9a;
              }
            }

            &:last-child {
              .custom-control-label {
                border-radius: 0 100px 100px 0;
                border: 1px solid #7b7c9a;
              }
            }
          }
        }
      }

      .summary {
        box-shadow: none;
        line-height: 18px;
        border-radius: 3px;
        padding-top: 38px !important;
        padding: 50px;
        background-color: #fff;
        box-shadow: 0px 3px 6px #00000010;
        height: 780px;
        position: relative;

        @media (max-width: 479px) {
          padding: 15px !important;
          //padding-left: 25px !important;
        }

        @media (max-width: 1390px) {
          height: 736px;
          padding-top: 32px !important;
          //padding-left: 25px !important;
        }

        &__title {
          font-size: 14px;
          font-weight: bold;
          color: $mainColor;
          margin-bottom: 20px;
          text-align: center;
        }

        &__section {
          &__label {
            position: relative;
            color: $mainColor !important;
            font-weight: 500;
            color: $thirdColor;
            margin-bottom: 20px !important;
            font-size: 16px !important;

            @media (max-width: 479px) {
              i {
                color: #0855c4;
              }
            }

            button {
              border: none;
              background-color: transparent;

              // &::before {
              //     content: "";
              //     position: absolute;
              //     margin-left: 20px;
              //     width: 14px;

              //     height: 14px;
              //     border: 2px solid #000;
              //     border-top: none;
              //     border-right: none;
              //     transform: rotate(-45deg);
              // }
            }

            // &.drop {
            //     button::before {
            //         top: 7px;
            //         transform: rotate(135deg);
            //     }
            // }
          }

          &__infouser {
            margin-top: 25px;

            @media (max-width: 1390px) {
              margin-top: 16px !important;
              margin-bottom: 18px !important;
            }

            span {
              font-size: 16px;
              font-weight: 500;
              color: $primaryGray;
            }
          }

          &__detail {
            letter-spacing: -0.5px;
            display: flex;
            margin-bottom: 7px;
            font-size: 16px;
            color: #6e6b7b;

            &:last-child {
              margin-top: 5px;
            }

            span {
              width: 165px;
              word-spacing: 2px;
              color: $primaryGray;

              &+span {
                width: calc(100% - 165px);
                word-break: break-word;
              }

              @media (max-width: 479px) {
                text-align: left;
              }
            }

            b {
              color: $primaryGray;
              font-weight: 600;
            }

            .w-100 {
              word-spacing: 4px;
              font-size: 15px;
              display: flex;
              text-align: center;
              align-items: center;
              justify-content: center;
              margin-top: 5px;
              line-height: 20px;
              padding-bottom: 10px;

              @media (max-width: 1366px) {
                font-size: 14px !important;
                line-height: 14px !important;
              }

              span:last-child {
                color: #7a8af6;
                text-decoration: underline;
                font-size: 15.5px;
                line-height: 20px;

                @media (max-width: 1366px) {
                  font-size: 14px !important;
                  line-height: 14px !important;
                }
              }
            }

            .txt {
              word-spacing: 3px;
              line-height: 20px;
              font-size: 15px;
              margin-top: 15px;

              @media (max-width: 1366px) {
                font-size: 14px !important;
                line-height: 14px !important;
                text-align: left;
              }
            }
          }
        }

        &__action {
          color: $mainColor;
          font-size: 13px;
        }
      }

      .summary-alert {
        background-color: rgba($mainColor, 0.3);
        border-radius: 8px;
        margin-bottom: 15px;
        padding: 25px;
        margin-top: 15px;
        color: $secondColor;
        display: flex;

        i {
          margin-right: 10px;
          margin-top: 4px;
        }
      }

      @media (max-width: 479px) {
        .form-group {
          .btn-main {
            width: 100%;
          }
        }

        .summary {
          background-color: #f1f4f9 !important;
          height: auto;
          padding: 10px 0;

          &__section {
            &__detail {
              &:last-child {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 479px) {
    background-color: #fff;
    padding-top: 5px;

    .chat-button {
      display: none !important;
    }

    &__stepper {
      margin-top: 10px;
    }
  }
}

/**BOTON-WPP */
.chat-button {
  position: fixed;
  bottom: 6rem;
  right: 20px;
  z-index: 1000;

  &.phone {
    bottom: 12rem;
  }

  &:hover {
    .chat-button__label {
      opacity: 1;
      right: calc(100% - 30px);
    }
  }

  img {
    width: 70px;
    height: 70px;
    position: relative;
    z-index: 10;
    // border-radius: 50%;
  }

  &__label {
    position: absolute;
    width: 330px;
    background-color: #7b7c9a;
    border-radius: 100px 0 0 100px;
    right: -400px;
    padding: 12px 40px 12px 25px;
    transform: translateY(-50%);
    top: 50%;
    color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0.2);
    transition: 300ms;
    opacity: 0;
  }

  @media (max-width: 479px) {
    bottom: 90px !important;
  }
}

.row-space {
  width: 50px;
}

/**STEP-2 */
.programSavings {
  /*padding-left: 120px !important;*/

  @media screen and (min-width: $tabletBreak) {
    margin-right: 48px !important;
    padding-right: 22px !important;
  }

  @media (max-width: 479px) {
    margin-right: 0px !important;

    .btnPink {
      .btn-pink {
        height: 50px;
        width: 68%;
        font-size: 14px;
        color: $headerFontColor;
        background-color: $pink;
        font-weight: 500;
        margin-bottom: 20px;
      }

      .btn-outline-main {
        background-color: transparent;
        background-image: none;
        border-color: #0855c4 !important;
        height: 50px;
        width: 68%;
        font-size: 14px;
        font-weight: 500;
      }

      img {
        width: 30px;
        margin-left: 5px;
      }
    }

    .btn-wapp {
      background-color: #01adee;
      padding: 0 15px;
      height: 55px;
      color: #fff;
      width: 220px;
      max-width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100px;
      margin-top: 6px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 40px;

      &:focus,
      &:active {
        background-color: #01adee;
        color: #fff;
      }

      img {
        width: 35px;
        height: 35px;
        margin-right: 10px;
      }

      span {
        text-align: left;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  &__card {
    .card-plan {
      @media (max-width: 479px) {
        border: none;

        .card-body {
          padding: 15px;
          // height: 82px;
          // background-color: #E2F7FF;
        }
      }
    }

    .card-body {
      .loader {
        min-height: 80px !important;

        .text-second {
          font-size: 20px;
          margin-top: 10px;
        }
      }
    }
  }

  &.a-side {
    padding: 0 !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  &__content {
    h6 {
      font-size: 16px !important;
      color: $primaryBlue;
      font-weight: 500;
    }

    label {
      font-size: 14px !important;
      color: $colorGrey;

      @media (max-width: 915px) {
        margin-bottom: 30px;
      }
    }
  }

  .card-form {
    //height: 396px !important;
    //width: 420px !important;
    height: 100%;
    width: 100% !important;
    padding: 15px;
    border: none;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);

    @media (max-width: 479px) {
      padding: 0;
      margin: 0;
      box-shadow: none;
    }
  }

  .card-form {
    border-radius: 0.5 !important;

    @media (max-width: 479px) {
      width: 100% !important;
      height: fit-content !important;
    }
  }

  .ahorroMes {
    margin-bottom: 30px !important;

    .vue-slider-dot-tooltip-inner {
      &.vue-slider-dot-tooltip-inner-top {
        padding: 0 !important;
      }
    }

    b {
      font-size: 18px;
      font-weight: normal;
      color: #0855c4;
    }
  }

  .ahorroMes {
    b {
      font-size: 17px;
      font-weight: 500 !important;
    }
  }

  .yearSaving {
    &.form-group {
      margin-bottom: 0px;
    }

    label {
      margin-bottom: 25px !important;
    }

    b {
      font-weight: 500 !important;
      font-size: 18px;
      margin-bottom: 20px;
    }
  }

  .yearSaving {
    margin-bottom: 10px !important;

    b {
      font-size: 17px;
      font-weight: 500;
    }
  }

  .rememberme {
    font-size: 16px;
  }

  .text {
    font-size: 14px;
  }
}

/**NUMBER-AMOUNT-SELECTOR */
.vue-slider-dot-tooltip-inner {
  border-color: #fff !important;
  background-color: #fff !important;
  box-shadow: none !important;
  font-weight: 500;
}

/**RAIL-SELECTOR */
.vue-slider .vue-slider-rail {
  background-color: #c5c5c5;
}

.vue-slider .vue-slider-dot .vue-slider-dot-handle {
  border: 8px solid $primaryBlue;
}

.vue-slider-dot-handle {
  cursor: pointer;
  border-radius: 50%;
  background-color: headerFontColor;
}

/**CARD-MIPLAN */
.Myplan {
  margin-right: 81px;

  .card-plan {
    border-radius: 20px;
    border: none;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  }

  &.a-side {
    padding: 0 !important;
    margin-right: 20px;
  }

  .card-body {
    padding-top: 6px !important;
    padding-bottom: 13px !important;
  }
}

/**CARD-PERSONAL-DATE */
.personal-date {
  margin: 20px 0px;

  &__card {
    border: none !important;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);

    .card-body {
      .form-group {
        margin-bottom: 10px;

        .form-control {
          height: 40px;
        }

        .btn-send {
          width: 180px;
          height: 48px;
        }

        select.form-control {
          background-position-y: 16px !important;
          color: black;
        }
      }

      .form-select {
        border: 1px solid #c5c5c5;
        border-radius: 4px;
        border-width: 2px;
        height: 57px;
        font-size: 14px !important;
        color: #474a4cc9;

        @media (max-width: 479px) {
          //margin-bottom: 24px;
          height: 45px;
        }
      }
    }
  }
}

/**BOTON-WHATSAPP */
.contentwpp {
  &__item {
    display: flex;
    font-size: 12px;
    align-items: center;

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    img {
      width: 35px;
      height: 45px;
      margin-right: 10px;
    }

    span {
      text-align: center;
      font-weight: 500;
      color: $mainColor;
    }
  }

  .btn-wapp {
    background-color: #01adee;
    padding: 0 15px;
    height: 55px;
    color: #fff;
    width: 220px;
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    margin-top: 6px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;

    &:focus,
    &:active {
      background-color: #01adee;
      color: #fff;
    }

    img {
      width: 35px;
      height: 35px;
      margin-right: 10px;
    }

    span {
      text-align: left;
      font-size: 14px;
      font-weight: 500;
      line-height: 14px;
    }
  }
}

/**BARRA-AZUL-AMOUNT-SELECTOR */
.vue-slider .vue-slider-process {
  background-color: $primaryBlue;
}

/**FINAL-STEP-RESUMEN-PAGO */
.finalstep {
  .card-form {
    border: none;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
    padding-left: 5px;
    padding-right: 5px;
  }

  .card {
    &__title {
      span {
        font-size: 14px;
        color: $primaryGray;
      }
    }
  }

  .row {
    .stepthree {
      text-align: center;

      span {
        font-size: 20px;
        color: #0855c4;
        margin-bottom: 15px;
      }
    }
  }

  .titular-dates {
    width: 520px;

    .card-form {
      margin-bottom: 30px;
      box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);

      @media (max-width: 479px) {
        box-shadow: none !important;
      }
    }

    .PayCard {
      .payments-cards {
        span {
          color: $primaryGray;
          font-size: 14px;
        }
      }
    }

    &__form-card {
      @media (max-width: 479px) {
        background-color: #f1f4f9;

        .PayCard {
          span {
            color: $sixtColor;
          }
        }
      }
    }

    &__form {
      box-shadow: none;
    }
  }

  // .col-md-5{
  //     width: 500px;
  // }
}

/**FORMULARIO-TARJETAS */
.cardPays {
  &__form {
    box-shadow: none !important;

    @media (max-width: 479px) {
      box-shadow: none !important;
    }
  }
}

// .payment-cards {
//     span{
//         padding-bottom: 10px;
//     }
//     .card-brands {

//         display: flex;
//         justify-content: center;
//         background-color: red;

//         img {
//             width: 250px !important;
//         }
//     }
// }

.custom-control.custom-checkbox {
  display: flex;
  align-items: baseline;

  .custom-control-input {
    opacity: 0;
    margin-right: 20px;
  }

  .custom-control-label {
    color: $colorGrey !important;
    margin-top: 2px;

    b {
      color: $mainColorHover !important;
    }
  }

  .custom-control-input:checked~.custom-control-label::after {
    content: "";
    color: white;
    left: 5px;
    font-weight: lighter;
    display: flex;
    justify-content: center;
    background-size: 57%;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("../../assets/check-white.svg");
  }

  .custom-control-label {
    span {
      color: $primaryBlue !important;
      font-weight: 500;
    }
  }

  .custom-control-label:after {
    position: absolute;
    top: 0.225rem;
    left: 5px;
    display: block;
    width: 18px;
    height: 18px;
    content: "";
  }

  span {
    &::before {
      content: "";
      position: absolute;
      top: 3px;
      z-index: 1;
      left: 8px;
      color: white;
      width: 15px;
      height: 15px;
    }
  }

  .custom-control-label:before {
    position: absolute;
    top: 0.225rem;
    display: block;
    width: 18px;
    height: 18px;
    left: 5px;
    pointer-events: none;
    content: "";
    background-color: $headerFontColor;
    border: 1px solid #d8d6de;
  }

  .custom-control-input:checked~.custom-control-label::after {
    background-color: $fiftColor;
    border-color: $fiftColor;
    border-radius: 50%;

    @media (max-width: 479px) {
      background-color: $fiftColor;
      border-color: $fiftColor;
    }
  }

  .custom-control-input:checked~.custom-control-label:before {
    border-color: #7367f0;
    background-color: #7367f0;
  }
}

/**PASO-3-CARD-RESUMENPAGO-BORDES */
@media (max-width: 479px) {
  .summary::after {
    content: "";
    display: block;
    height: 100%;
    position: absolute;
    width: 100px;
    top: 1px;
    background-color: #f1f4f9 !important;
    left: 100%;
  }

  .summary::before {
    content: "";
    display: block;
    height: 100%;
    position: absolute;
    width: 100px;
    top: 1px;
    background-color: #f1f4f9 !important;
    right: 100%;
  }

  .PayCard::after {
    content: "";
    display: block;
    height: 100%;
    position: absolute;
    width: 100px;
    top: 1px;
    background-color: #f1f4f9 !important;
    left: 100%;
  }

  .PayCard::before {
    content: "";
    display: block;
    height: 100%;
    position: absolute;
    width: 100px;
    top: 1px;
    background-color: #f1f4f9 !important;
    right: 100%;
  }
}

.amount-selector {
  .vue3-slider {
    .tooltip {
      display: block !important;
      opacity: 1 !important;
    }

    .handle {
      transform: scale(2.5);
    }
  }
}

.vue3-slider {
  .tooltip {
    display: block !important;
    opacity: 1 !important;
  }

  .handle {
    transform: scale(1.5);
  }
}

.close {
  border: none !important;
}

/**Modal-Quote */
.modal .modal-dialog .modal-content .modal-body {
  a {
    color: #0855c4 !important;
  }

  .card-text {
    color: #6e6b7b;
  }
}

.vue3-slider {
  .tooltip {
    z-index: 1050 !important;
  }
}

/**Modal-Login */

.modal-login {

  .modal-header,
  .modal-footer {
    display: none;
  }

  .modal-sm {
    @media (min-width: $desktopBreak) {
      width: 400px !important;
      max-width: 400px;
    }
  }

  .modal-content {
    border-radius: 25px !important;
  }

  .quote-card {
    width: 100%;
    padding: 15px;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
    background-color: white;

    form {
      .form-group {
        font-family: $firstFont;
        font-weight: 400;
        font-size: 14px;
        position: relative;
        display: flex;
        align-items: center;
        margin: 0px 15px 12px 0px;

        .error {
          display: none;
        }

        &.invalid {
          display: block;

          .error {
            font-weight: 600;
            font-size: 13px;
            display: block;
            text-align: left;
            margin: 2px 0px 0px 10px;
            color: $primaryRed;
            width: 100%;
          }
        }

        input[type="radio"] {
          opacity: 0;
          margin-right: 14px;
        }

        input[type="radio"]::after {
          content: "";
          position: absolute;
          z-index: 5;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
          background-color: transparent;
        }

        input[type="radio"]:checked~label::before {
          background-color: $primaryBlue;
        }

        input[type="radio"]:checked~label::after {
          border: 1px solid $primaryBlue;
        }

        input[type="radio"]+label::before {
          content: "";
          position: absolute;
          z-index: 1;
          top: 0;
          left: 0;
          width: 19px;
          height: 19px;
          border-radius: 50%;
          background-color: transparent;
          cursor: pointer;
          transition: 0.3s;
        }

        input[type="radio"]+label::after {
          content: "";
          position: absolute;
          z-index: 1;
          top: 0;
          left: 0;
          width: 19px;
          height: 19px;
          border-radius: 50%;
          border: 1px solid #d8d6de;
          cursor: pointer;
          transition: 0.3s;
        }

        //

        .form-control {
          font-family: $firstFont;
          font-weight: 400;
          width: 100%;
          margin-top: 12px;
          padding: 10px;
          text-align: center;
          outline: none;
          border-radius: 5px !important;
          border: 1px solid #d8d6de;
          transition: 0.3s;
        }

        .form-control::placeholder {
          color: #c2c2c2;
        }

        .form-control:focus {
          border: 1px solid $primaryPurple;
          padding-left: 20px;
          box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.1);
        }

        //

        .form-btn {
          font-family: $firstFont;
          font-weight: 500;
          font-size: 17px;
          width: 100%;
          border-radius: 5px;
          padding: 13px;
          border: none;
          color: white;
          background-color: $primaryPink;
        }

        //

        h6 {
          font-weight: 500;
          font-size: 18px;
          width: 100%;
          display: block;
          text-align: center;
          color: $primaryBlue;
          margin: 0;
        }

        p {
          font-size: 14px;
          margin: 0;
          padding-right: 10px;
        }

        img {
          width: 100px;
        }

        span {
          display: block;
          text-align: center;
          width: 100%;

          a {
            font-weight: 500;
            color: $primaryBlue;
          }
        }
      }
    }
  }
}

.modal-login {
  .modal-body {
    padding: 10px;
  }

  .btncustom {
    &__form {
      .custom-control-label:checked~.custom-control-label::before {
        background-color: #7367f0 !important;
        border-color: #7367f0 !important;
      }

      .custom-control-label:checked~.custom-control-label::after {
        background-color: #7367f0 !important;
        border-color: #7367f0 !important;
      }
    }
  }
}

.success {
  text-align: center;

  h2,
  h3 {
    color: #0855c4;
  }

  .actions {
    display: flex;

    .btn-pink {
      background-color: $primaryPink;
      border-radius: 5px;
      height: 52px;
      font-size: 16px;
      color: #fff;
      width: 200px;
      margin-left: 0 !important;
      margin-right: 20px;
    }

    .btn-outline-main {
      border-radius: 5px;
      height: 52px;
      font-size: 16px;
      color: #fff;
      width: 200px;
      margin-left: 0 !important;
    }
  }
}

/**Loading */
.modal-loading .modal-dialog .modal-content .modal-body {
  color: #0855c4;
  font-weight: bolder;
  font-size: 28px;
  display: flex !important;
  align-items: center !important;
  text-align: center !important;
}

/**/
.modal-free-month {
  &__head {
    margin-top: 15px;
  }

  &__countdown {
    background: linear-gradient(180deg,
        rgb(41, 211, 239) 21%,
        rgb(37, 161, 181) 100%,
        rgb(2, 0, 36) 100%);
  }

  &__content {
    @media (max-width: $mobileBreak) {
      padding: 20px 25px 20px 25px !important;
    }

    &__title {
      position: relative;
    }

    &__promo-wpp {
      color: $mainColorHover;
      font-size: 15px;
      margin-top: 30px;
      padding-left: 30px;
      padding-right: 30px;
      line-height: 18px;
    }

    .row {
      display: flex;
      align-items: center;
      margin-top: 20px;

      @media (max-width: $mobileBreak) {
        flex-wrap: nowrap;
        margin: 20px 50px 20px 0px;
      }

      @media (max-width: $desktopBreak) {
        margin: 0px 0px 0px 15px;
        padding: 0;
      }

      .col-2 {
        position: relative;

        @media (max-width: $mobileBreak) {
          margin: 0px 0px 0px 15px;
          padding: 0;
        }

        .title-img {
          position: absolute;
          z-index: 1;

          img {
            @media (min-width: $mobileBreak3) {
              width: 110px;
            }

            @media (min-width: $desktopBreak) {
              width: 100px;
            }
          }

          @media (min-width: $mobileBreak3) {
            top: -60px;
            right: -60px;
          }

          @media (min-width: $desktopBreak) {
            top: -65px;
            right: -100px;
          }
        }
      }

      .col {
        margin-left: 0px;
        margin-right: 20px;
        padding-left: 70px;

        @media (max-width: $mobileBreak) {
          margin: 0;
          padding: 0;
        }

        @media (min-width: $desktopBreak) {
          padding-left: 40px;
        }

        .title {
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
          background-image: url("../../assets/images/app/Trazado-25166.png");
          background-color: transparent;
          height: 120px;
          box-shadow: none;

          @media (max-width: $mobileBreak) {
            width: 220px;
            margin-left: 45px;
          }

          @media (min-width: $mobileBreak3) {
            width: 230px;
            margin: 0 !important;
          }

          @media (min-width: $desktopBreak) {
            width: 240px;
          }

          &__text {
            text-align: center;

            @media (max-width: $mobileBreak) {
              padding: 5px 0px 5px 10px;
            }

            @media (min-width: $mobileBreak3) {
              padding: 0px 0px 20px 5px;
            }

            @media (min-width: $desktopBreak) {
              // padding: 10px 20px 10px 30px !important;
              padding: 12px 0px 10px 30px !important;
            }

            h4 {
              font-weight: 500 !important;
              font-size: 30px !important;
              width: 100%;
              padding: 0;
              margin: 0;
              // color: $primaryYellow;
              color: #fff;
              text-transform: none !important;

              @media (max-width: $mobileBreak) {
                font-size: 25px !important;
                align-items: center;
              }

              @media (min-width: $mobileBreak3) {
                font-size: 28px !important;
              }

              @media (min-width: $desktopBreak) {
                font-size: 30px !important;
              }

              span {
                font-weight: 700 !important;
                margin: 0px 0px 0px 10px;

                @media (max-width: $mobileBreak) {
                  margin: 0px 0px 0px 5px;
                }
              }
            }

            h5 {
              font-weight: 700;
              font-size: 30px;
              margin: 5px 0px 8px 0px;
              // color: $primaryYellow;
              color: #fff;
            }
          }
        }
      }
    }

    .bullets {
      position: relative;
      display: block;
      text-decoration: none !important;
      margin-top: 10px !important;
      padding: 10px 0px 10px 0px !important;
      max-width: 330px !important;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      br {
        display: none;
      }

      @media (max-width: $mobileBreak) {
        padding: 0 !important;
        margin: 10px 0px 0px 0px !important;

        br {
          display: block;
        }
      }

      &__title {
        display: flex;
        justify-content: center;
        align-items: center;

        @media (min-width: $mobileBreak3) {
          padding: 10px 20px 0px 20px !important;
        }

        @media (min-width: $desktopBreak) {
          padding: 10px 55px 10px 55px !important;
          margin: 0px 0px 0px 0px !important;
        }

        h4 {
          // font-size: 18px !important;
          font-size: 20px !important;
          margin: 0px !important;
        }

        img {
          &:first-child {
            width: 50px;
          }

          &:last-child {
            width: 45px;
          }
        }
      }

      &__list {
        position: relative;
        padding: 0px 40px 0px 40px !important;

        &__img {
          position: absolute;
          right: -70px;
          bottom: -30px;

          img {
            width: 64%;
          }

          @media (min-width: $mobileBreak3) {
            width: 90px;
            right: -20px;
            bottom: -15px;
          }

          @media (min-width: $desktopBreak) {
            width: 95px;
            right: -40px;
            bottom: -30px;
          }
        }
      }
    }

    ul {
      @media (max-width: $mobileBreak) {
        padding: 10px 30px 10px 40px !important;
      }

      li {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        span {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px !important;
          height: 30px !important;
        }

        &:nth-child(3) {
          align-items: flex-start;
        }

        p {
          font-size: 15px !important;
          line-height: 20px !important;
          margin: 0 !important;

          br {
            display: block !important;
          }

          img {
            width: 25px !important;
          }
        }
      }
    }

    .action {
      margin-top: 30px !important;
    }
  }
}

.modal-free-month2 {
  &__countdown {
    background: linear-gradient(180deg,
        rgb(41, 211, 239) 21%,
        rgb(37, 161, 181) 100%,
        rgb(2, 0, 36) 100%);
  }

  &__content {
    @media (max-width: $mobileBreak) {
      padding: 20px 25px 20px 25px !important;
    }

    .row {
      display: flex;
      align-items: center;

      @media (max-width: $mobileBreak) {
        flex-wrap: nowrap;
      }

      .col-2 {
        @media (max-width: $mobileBreak) {
          margin: 0px 0px 0px 15px;
          padding: 0;
        }

        .title-img {
          img {
            width: 80px;
          }
        }
      }

      .col {
        margin-left: 0px;
        margin-right: 20px;
        padding-left: 0;

        @media (max-width: $mobileBreak) {
          margin: 0;
          padding: 0;
        }

        .top-title {
          margin-left: 50px !important;
          font-size: 18px !important;
        }

        .title {
          width: 94%;

          @media (max-width: $mobileBreak) {
            width: 220px;
            margin-left: 45px;
          }

          &__text {
            padding: 10px 0px 10px 10px;

            @media (max-width: $mobileBreak) {
              padding: 5px 0px 5px 10px;
            }

            h4 {
              display: flex;
              font-weight: 500 !important;
              font-size: 30px !important;
              line-height: 24px !important;
              text-transform: none !important;

              @media (max-width: $mobileBreak) {
                font-size: 25px !important;
                align-items: center;
              }

              span {
                font-weight: 700 !important;
                margin: 0px 0px 0px 10px;

                @media (max-width: $mobileBreak) {
                  margin: 0px 0px 0px 5px;
                }
              }
            }
          }
        }
      }
    }

    .bullets {
      position: relative;
      display: block;
      text-decoration: none !important;
      padding: 10px 50px 10px 50px !important;
      max-width: 100% !important;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      br {
        display: none;
      }

      @media (max-width: $mobileBreak) {
        padding: 0 !important;
        margin: 10px 0px 0px 0px !important;

        br {
          display: block;
        }
      }

      &__title {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        margin: 0px 0px 10px 0px;

        h4 {
          font-size: 20px !important;
          margin: 0px 10px 0px 10px !important;
        }

        img {
          width: 40px;
        }
      }
    }

    ul {
      @media (max-width: $mobileBreak) {
        padding: 10px 30px 10px 40px !important;
      }

      li {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        span {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px !important;
          height: 30px !important;
        }

        &:nth-child(3) {
          align-items: flex-start;
        }

        p {
          line-height: 20px !important;
          margin: 0 !important;

          img {
            width: 25px !important;
          }
        }
      }
    }
  }
}

/**Slider-Quote */
.vue-slider:hover .vue-slider-dot-handle:hover {
  border-color: none;
  background-color: none;
  color: none;
}

.quote__step form .form-group .period-selector .custom-control-input:checked+.custom-control-label {
  border-color: #0855c4 !important;
  background: #0855c4 !important;
}
</style>